import React from "react";
//import { useEffect } from "react";
//import ReactHTMLTableToExcel from "react-html-table-to-excel";
//import * as FileSaver from "file-saver";
//import * as XLSX from "xlsx";
import { useEffect, useRef } from "react";
import api from "../../utils/api";
import { useState } from "react";
import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Spinner from "../../common/Spinner/Spinner";
import UserProfileModal from "../../components/ServiceRequests/Handholder/UserProfileModal";
//import UserServiceFeedbackModal from "../../components/ServiceRequests/Handholder/UserServiceFeedbackModal";
import UserFeedbackModal from "../../components/ServiceRequests/Handholder/UserFeedbackModal";
import find from "lodash/find";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { getServiceTypesMaster } from "../../utils/localStorage";
import FacilitatorFilterSection from "../../components/ServiceRequests/Facilitator/FacilitatorFilterSection";
import SPMFilterModel from "../../components/ServiceRequests/Facilitator/SPMFilterModel";
import EngagementFiltersModal from "../../components/ServiceRequests/Facilitator/EngagementFiltersModal";
import FacilitatorServiceTable from "../../components/ServiceRequests/Facilitator/FacilitatorServiceTable";
import axios from 'axios';
import SendNeftDetails from "../../components/ServiceRequests/Handholder/SendNeftDetails";


export default function FacilitatorServiceProgressionContainer(props) {

	const [clearCount, setClearCount] = useState(0);
	const [showFilterModal, setshowFilterModal] = useState(false);
	const toggleFilterModal = () => {
		setshowFilterModal(!showFilterModal);
	}


	const [selectedServiceRequestStatusList, setSelectedServiceRequestStatusList,] = useState([]);

	const [serviceRequestStatusList, setServiceRequestStatusList] = useState([]);

	const [showCancellationReasonModal, setShowCancellationReasonModal,] = useState(false);
	const toggleCancellationReasonModal = () => {
		setShowCancellationReasonModal(!showCancellationReasonModal);
	};
	const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState();
	const [selectedCancellationReason, setSelectedCancellationReason,] = useState();

	const [enableOtherDescriptionTextbox, setEnableOtherDescriptionTextbox,] = useState(false);

	const [cancellationReasonOtherDescription, setCancellationReasonOtherDescription,] = useState();
	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");

	useEffect(() => {
		enableCancelButton();
	}, [selectedCancellationReason, cancellationReasonOtherDescription]);

	const enableCancelButton = () => {
		if (selectedCancellationReason) {
			if (selectedCancellationReason.value === "Other") {
				if (
					cancellationReasonOtherDescription &&
					cancellationReasonOtherDescription.length > 0
				) {
					setEnableCancelButtonFlag("");
				} else setEnableCancelButtonFlag("disable");
			} else setEnableCancelButtonFlag("");
		} else setEnableCancelButtonFlag("disable");
	};


	//const [isLoading, setLoading] = useState(false);








	// const fetchUserRoleAccessReport = () => {
	// 	setIsLoading(true);
	// 	try {
	// 		api.getUserRoleAccessReport()
	// 			.then(({ data }) => {
	// 				toast(data["details"], {
	// 					autoClose: 5000,
	// 					type: toast.TYPE.SUCCESS,
	// 				});
	// 				window.open(data["generated_file"], "_self");
	// 				setIsLoading(false);
	// 			})
	// 			.catch((error) => {
	// 				setIsLoading(false);
	// 				toast(error["response"]["data"]["message"], {
	// 					autoClose: 5000,
	// 					type: toast.TYPE.ERROR,
	// 				});
	// 			});
	// 	} catch (error) {
	// 		setIsLoading(false);
	// 		toast("Server error.", {
	// 			autoClose: 5000,
	// 			type: toast.TYPE.ERROR,
	// 		});
	// 	}
	// };





	/** */
	const [serviceNameList, setServiceNameList] = useState([]);
	const [selectedServiceNameList, setSelectedServiceNameList] = useState([]);

	const [SPMStatusList, setSPMStatusList] = useState([
		{
			checked: false,
			label: "Ready for Progression",
			id: "Ready for Progression",
			code: "Ready for Progression",
		},
		{
			checked: false,
			label: "Awaiting For Information/Documents",
			id: "Awaiting For Information/Documents",
			code: "Awaiting For Information/Documents",
		},
		{
			checked: false,
			label: "Info & Docs Received",
			id: "Info & Docs Received",
			code: "Info & Docs Received",
		},
		{
			checked: false,
			label: "Payment Confirmed By Partner",
			id: "Payment Confirmed By Partner",
			code: "Payment Confirmed By Partner",
		},
		{
			checked: false,
			label: "Service Delivery Started",
			id: "Service Delivery Started",
			code: "Service Delivery Started",
		},
		{
			checked: false,
			label: "Service deliverables Ready",
			id: "Service deliverables Ready",
			code: "Service deliverables Ready",
		},
		// {
		// 	checked: false,
		// 	label: "Full Payment Requested",
		// 	id: "Full Payment Requested",
		// 	code: "Full Payment Requested",
		// },
		// {
		// 	checked: false,
		// 	label: "Full Payment Received",
		// 	id: "Full Payment Received",
		// 	code: "Full Payment Received",
		// },
		{
			checked: false,
			label: "Delivered",
			id: "Delivered",
			code: "Delivered",
		},
		{
			checked: false,
			label: "Cancelled",
			id: "Cancelled",
			code: "Cancelled",
		},
		{
			checked: false,
			label: "Refunded",
			id: "Refunded",
			code: "Refunded",
		}
	]);
	const [selectedSPMStatus, setSelectedSPMStatus] = useState([]);

	//Filter states
	const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
	const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);

	const toggleSPMStatus = (e) => {
		let temp = selectedSPMStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setSPMStatusList(tempSrStatus);
			setSelectedSPMStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setSPMStatusList(tempSrStatus);
			setSelectedSPMStatus(temp);
			// getServices(tableInstance);
		}
	};


	const [user, setUser] = useState();
	//const [tableInstance, setTableInstance] = useState(null);

	const [serviceRequests, setServiceRequests] = useState([]);
	const [newServiceRequests, setNewServiceRequests] = useState([]);
	const [backFromPartnerServiceRequests, setBackFromPartnerServiceRequests,] = useState([]);
	const [paymentReceivedServiceRequests, setPaymentReceivedServiceRequests,] = useState([]);
	const [serviceRequestsDueToday, setServiceRequestsDueToday] = useState([]);

	const [selectedService, setSelectedService] = useState();

	const [serviceRequestsOverdue, setServiceRequestsOverdue] = useState([]);

	const [selectedServiceRequest, setSelectedServiceRequest] = useState();
	const [tableData, setTableData] = useState([]);
	const [tableDataType, setTableDataType] = useState("serviceRequests");

	const [serviceRequestFilter, setServiceRequestFilter] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingContainer, setIsLoadingContainer] = useState(false);


	/*Need to talk to SP*/
	const [needToTalkToSPOptions, setneedToTalkToSPOptions] = useState([
		{
			value: true,
			label: "Yes",
		},
		{
			value: false,
			label: "No",
		},
	]);
	const [
		selectedNeedToTalkToSPOption,
		setSelectedNeedToTalkToSPOption,
	] = useState({
		value: false,
		label: "No",
	});
	/*End*/

	//Offline meet options
	const [offlinemeetoptions, setofflinemeetoptions] = useState([

		{
			value: true,
			label: "Opted",
		},
		{
			value: false,
			label: "Not Opted",
		},
	]);

	const [
		selectedofflinemeetoptions,
		setselectedofflinemeetoptions,
	] = useState({
		value: false,
		label: "Not Opted",
	});


	//End






	/**
	 * Catalog modal vars and callbacks
	 */

	const [allCatalogs, setAllCatalogs] = useState();

	const fetchallCatalogs = async () => {
		let { data } = await api.getCatalogueForServiceRequest();
		setAllCatalogs(data);
	};
	const [isCatalogueModalOpen, setIsCatalogueModalOpen] = useState(false);
	const [catalogueByServiceRequest, setCatalogueByServiceRequest] = useState(
		[]
	);
	const [selectedCatalog, setSelectedCatalog] = useState();

	const toggleCatalogModal = () => {
		setIsCatalogueModalOpen(!isCatalogueModalOpen);
	};

	const fetchCatalogueByService = async (e) => {
		let { data } = await api.getCatalogueForServiceRequest(
			e["sServiceCode"]
		);
		setCatalogueByServiceRequest(data);
	};

	const showCatalogModalClick = (e) => {
		fetchCatalogueByService(e);
		toggleCatalogModal();
		setSelectedCatalog(e["sCatalogueId"]);
	};

	/*Service Filter logic change states*/
	const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
	const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
	/*Service Filter logic change states end*/

	/*Package Filter states*/
	const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
	const [servicesThroughPackageOptions, setservicesThroughPackageOptions,] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedServicesThroughPackageOption,
		setSelectedServicesThroughPackageOption,
	] = useState({
		value: "all",
		label: "All",
	});
	/*Package Filter States end*/

	/**
	 * user profile modal
	 */
	const [showUserProfileModal, setUserProfileModalVisibility] = useState(
		false
	);
	const [userProfileInitData, setUserProfileInitData] = useState({});
	const [userProfileEditableData, setUserProfileEditableData] = useState({});
	const [nUserId, setUserId] = useState();
	const [nResourceInstanceIdForUserProfile, setnResourceInstanceIdForUserProfile] = useState();
	const [sBusinessNameForUserProfile, setsBusinessNameForUserProfile] = useState();
	const [sSectorNameForUserProfile, setsSectorNameForUserProfile] = useState();
	const [sCurrentServiceRequestStateForUserProfile, setsCurrentServiceRequestStateForUserProfile] = useState();


	const [nResourceInstanceIdForFeedback, setnResourceInstanceIdForFeedback] = useState();
	const [refExternalServicePartnerEmailIDForFeedback, setrefExternalServicePartnerEmailIDForFeedback] = useState();
	const [sServiceNameForFeedback, setsServiceNameForFeedback] = useState();
	const [showServiceFeedbackModal, onSetShowServiceFeedbackModal] = useState(false);
	const toggleServiceFeedbackModal = () => {
		onSetShowServiceFeedbackModal(!showServiceFeedbackModal);
	};

	const handleOnShowFeedback = (e, origin) => {
		setnResourceInstanceIdForFeedback(origin["nResourceInstanceId"]);
		setsServiceNameForFeedback(getServiceName(origin));
		if (origin.refExternalServicePartner && origin.refExternalServicePartner.sServicePartnerEmail) {
			setrefExternalServicePartnerEmailIDForFeedback(origin.refExternalServicePartner.sServicePartnerEmail)
		}
		toggleServiceFeedbackModal();
	};



	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

	/*Engagement filter modal*/

	const [showEngagementFiltersModal, onSetShowEngagementFiltersModal] = useState(false);
	const toggleEngagementFiltersModal = () => {
		onSetShowEngagementFiltersModal(!showEngagementFiltersModal);
	};

	const [introductoryConversationOptions, setItroductoryConversationOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
	]);

	const [selectedIntroductoryConversationOption, setSelectedIntroductoryConversationOption,] = useState(null);

	const [callStatusOptions, setCallStatusOptions] = useState([
		{
			value: "Connected",
			label: "Connected",
		},
		{
			value: "Not Connected",
			label: "Not Connected",
		},
	]);

	const [selectedCallStatusOption, setSelectedCallStatusOption,] = useState(null);

	const [StayEnagegedOptions, setStayEnagegedOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
	]);

	const [selectedStayEnagegedOption, setSelectedStayEnagegedOption,] = useState(null);
	const [userSharedChallegesGoalsOptions, setuserSharedChallegesGoalsOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
	]);

	const [selecteduserSharedChallegesGoalsOption, setSelecteduserSharedChallegesGoalsOption,] = useState(null);
	const [deAsraAbleHelpforChallegesGoalsOptions, setdeAsraAbleHelpforChallegesGoalsOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
	]);

	const [selecteddeAsraAbleHelpforChallegesGoalsOption, setSelecteddeAsraAbleHelpforChallegesGoalsOption,] = useState(null);
	const [extendedData, setExtendedData] = useState([]);
	const [resourceId, setResourceId] = useState();
	const [loader, setLoader] = useState(false);
	const [progressionDate, setProgressionDate] = useState("");


	//clear filter

	//filter clear
	const handleSearchClick = async () => {
		if (showFilterModal) {
			toggleFilterModal();
		}

		getServices(tableInstance);
	};

	// const handleClearFilterSearch = () => {		
	// 	setSearchTerm("");
	// 	//setSelectedMovedToSPMStatus(null);
	// 	setSelectedServicesThroughPackageOption({
	// 		value: "all",
	// 		label: "All",
	// 	});
	// 	//setSelectedServiceRequestStatusList(null);
	// 	//setSelectedPaymentStatus(null);
	// 	setSelectedServiceNameListForFilter(null);
	// 	setSelectedPackageNameListForFilter(null);
	// 	setSelectedServiceStatusListForFilter(null);
	// 	// let tempPaymentStatus = paymentStatusList.map((x) => {
	// 	// 	x.checked = false;
	// 	// 	return x;
	// 	// });
	// 	// setPaymentStatusList(tempPaymentStatus);

	// 	// let tempSrStatus = serviceRequestStatusList.map((x) => {
	// 	// 	x.checked = false;
	// 	// 	return x;
	// 	// });
	// 	// setServiceRequestStatusList(tempSrStatus);

	// 	// setSearchTerm("");		
	// 	// setFollowUpDateFrom("");
	// 	// setFollowUpDateTo("");
	// 	// setSearchFilter(null);
	// 	// setClearCount(clearCount+1);	
	// 	// let tempserach = SearchByDropdownList.map((x) => {
	//     //     x.checked = false;
	//     //     return x;
	//     // });
	//     //setSearchByDropdownList(tempserach);
	// 	toggleFilterModal();
	// };

	// const onSearchClicked = () => {
	// 	getServices(tableInstance);
	// };

	const handleClearFilterSearch = () => {
		setDateFilter({
			value: "dtServiceProgression",
			label: "Progression On",
		});
		setCustomerFilterValue("");
		setFromDate("");
		setToDate("");

		setSelectedServiceNameListForFilter([]);
		setSelectedServiceStatusListForFilter([]);
		setSelectedPackageNameListForFilter([]);

		setSelectedIntroductoryConversationOption(null);
		setSelectedCallStatusOption(null);
		setSelectedStayEnagegedOption(null);
		setSelecteduserSharedChallegesGoalsOption(null);
		setSelecteddeAsraAbleHelpforChallegesGoalsOption(null);
		setClearCount(clearCount + 1);
	};


	useEffect(() => {
		if (clearCount > 0) {
			getServices(tableInstance);
		}
	}, [clearCount]);



	/* End */




	const onEngagementFilterSearchClicked = () => {
		toggleEngagementFiltersModal();
		getServices(tableInstance);
	};

	const onClearEngagementFilterClicked = () => {
		setSelectedIntroductoryConversationOption(null);
		setSelectedCallStatusOption(null);
		setSelectedStayEnagegedOption(null);
		setSelecteduserSharedChallegesGoalsOption(null);
		setSelecteddeAsraAbleHelpforChallegesGoalsOption(null);
	};

	/*Engagement filter modal End*/

	useEffect(() => {
		if (clearCount > 0) {
			getServices(tableInstance);
		}
	}, [clearCount]);

	// useEffect(() => {
	// 	const serviceStatus = SPMStatusList.map((idx) => {
	// 		return {
	// 			label: idx.code,
	// 			value: idx.code,
	// 			id: idx.code,
	// 		};
	// 	});
	// 	setServiceStatusNameListForFilter(serviceStatus);
	// }, []);


	/**
	 * user profile callbacks
	 */
	const handleOnClickUser = async (e, origin) => {

		await api.getMyServiceRequestsFacilitatorExpand(
			origin['nResourceInstanceId']
		)
			.then((response) => {
				setUserId(response.data.results[0]?.nUserId);
				setsBusinessNameForUserProfile(response.data.results[0]?.sBusinessName);
				setnResourceInstanceIdForUserProfile(origin["nResourceInstanceId"]);
		// setsBusinessNameForUserProfile(origin["sBusinessName"]);
		if (origin.refExternalServicePartner && origin.refExternalServicePartner.sServicePartnerEmail) {
			setrefExternalServicePartnerEmailIDForFeedback(origin.refExternalServicePartner.sServicePartnerEmail)
		}
		setsCurrentServiceRequestStateForUserProfile(response.data.results[0]?.refCurrentState && response.data.results[0]?.refCurrentState.sServiceState || "");
		if (response.data.results[0]?.refBusinessSectorNew) {
			setsSectorNameForUserProfile(response.data.results[0]?.refBusinessSectorNew.sSectorName);
		}
		else {
			setsSectorNameForUserProfile(null);
		}

		toggleUserProfileModal();

			})
			.catch((error) => {
				// setLoader(false)
			});
		// setUserId(origin["nUserId"]);
		// setnResourceInstanceIdForUserProfile(origin["nResourceInstanceId"]);
		// // setsBusinessNameForUserProfile(origin["sBusinessName"]);
		// if (origin.refExternalServicePartner && origin.refExternalServicePartner.sServicePartnerEmail) {
		// 	setrefExternalServicePartnerEmailIDForFeedback(origin.refExternalServicePartner.sServicePartnerEmail)
		// }
		// setsCurrentServiceRequestStateForUserProfile(origin.refCurrentState && origin.refCurrentState.sServiceState || "");
		// if (origin.refBusinessSectorNew) {
		// 	setsSectorNameForUserProfile(origin.refBusinessSectorNew.sSectorName);
		// }
		// else {
		// 	setsSectorNameForUserProfile(null);
		// }

		// toggleUserProfileModal();
	};

	const toggleUserProfileModal = () => {
		// e.preventDefault();
		setUserProfileModalVisibility(!showUserProfileModal);
	};

	const handleUserProfileDataChanged = (name, value) => {
		const updated = {
			...userProfileEditableData,
			[name]: value,
		};
		setUserProfileEditableData(updated);
	};

	// eslint-disable-next-line no-unused-vars
	const handleSaveUserProfileData = async () => {
		//make api call to save details.
		const { sNEFTDetails } = neftDetails;
		if (sNEFTDetails && sNEFTDetails.length > 0) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails,
					bNEFTPayment: true,
					nResourceInstanceId,
				});
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} catch (error) {
				toast(`Something went wrong.Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
	};

	const createUserProfile = async () => {
		try {
		} catch (error) { }
	};

	const updateSelectedServiceRequest = (data) => {
		setSelectedServiceRequest(data);
	};


	/*
	 * NEFT modal data
	 */
	const [showNeftModal, setNeftModalVisibility] = useState(false);
	const [neftDetails, setNeftDetails] = useState({});

	/**
	 * NEFT callbacks
	 */
	const toggleNeftModal = (e) => {
		let user = getUser();
		if (e && e["refFacilitator"]) {
			if (
				user.access_rights["SERVICE"] &&
				user.access_rights["SERVICE"].includes("MANAGE") == false
			) {
				toast(`You are not a facilitator.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			if (user.email !== e["refFacilitator"]["email"]) {
				toast("You are not the assigned facilitator.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			// setNeftDetails({
			// 	bNEFTPayment: e["bNEFTPayment"],
			// 	sNEFTDetails: e["sNEFTDetails"],
			// 	sNEFTTxnId_2: e["sNEFTTxnId_2"],
			// 	fAmountReceived_2: e["fAmountReceived_2"],
			// });
			setNeftDetails({
				bNEFTPayment: e["sNEFTDetails2"] !==null ? e["bNEFTPayment"] : false,
				sNEFTDetails: e["sNEFTDetails2"] ? e["sNEFTDetails2"] : "",
				sNEFTTxnId_2: e["sNEFTTxnId_2"],
				fAmountReceived_2: e["fAmountReceived_2"],
			});
			setSelectedServiceRequest(e);
		}
		// 		if (false) {
		// 			setSelectedServiceRequest("");
		// 			setNeftDetails({});
		// 		} else {
		// 			setNeftDetails({
		// 				bNEFTPayment: e["bNEFTPayment"],
		// 				sNEFTDetails: e["sNEFTDetails"],
		// 				sNEFTTxnId_2: e["sNEFTTxnId_2"],
		// 				fAmountReceived_2: e["fAmountReceived_2"],
		// 			});
		// 			setSelectedServiceRequest(e);
		// 		}
		setNeftModalVisibility(!showNeftModal);
	};

	const handleNeftDetailsChanged = (name, value) => {
		if (name === "sNEFTTxnId") {
			if (/^[a-z0-9]*$/i.test(value) === false) return;
			name = name.concat("_2");
		}
		if (name === "fAmountReceived") {
			if (/^[0-9]*$/i.test(value) === false) return;
			if (value === undefined || value === "") value = 0;
			name = name.concat("_2");
		}
		const updated = {
			...neftDetails,
			[name]: value,
		};
		setNeftDetails(updated);
	};

	const getServiceCostAmountAfterDiscount = (originalAmount, discountAmount) => {
        const gstRate = 0.18; // 18% GST Rate
        const basePrice = originalAmount / (1 + gstRate)
        const discountedPrice = Math.round(basePrice) - Math.round(discountAmount)
        const serviceCostAfterDiscountIncludingGst = discountedPrice * 1.18
        // return serviceCostAfterDiscountIncludingGst.toFixed(2)
        return Math.round(serviceCostAfterDiscountIncludingGst)
    }

	const computeFinalPayableAmount = (sr) => {
		if (!sr.fDiscountAmount) return null;
	
		// if ((sr.fDiscountAmount - sr.fAmountSecond) === 0) return 0;
		if ((Math.round(sr.fDiscountAmount) - Math.round(sr.fAmountSecond)) === 0) return 0;

	
		if (sr.nPackageInstanceId) {
			const base = sr.fPackageOfferAmount;
	
			if (sr.fDiscountAmount > base) return 0;
	
			if (sr.dtCouponExpiryDate) {
				const isExpired = new Date(sr.dtCouponExpiryDate) < new Date();
				return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
			}
	
			return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
		}
	
		if (sr.sPaymentMode === "2_Step_Payment") {
			if (sr.fDiscountAmount > sr.fAmountFirst) {
				return getServiceCostAmountAfterDiscount(sr.fAmountFull, sr.fDiscountAmount);
			}
			else{
				return getServiceCostAmountAfterDiscount(sr.fAmountSecond, sr.fDiscountAmount);
				
			}
	
			// return sr.fAmountSecond;
		}
	
		const base = sr.fAmountSecond;
	
		if (sr.dtCouponExpiryDate) {
			const isExpired = new Date(sr.dtCouponExpiryDate) < new Date();
	
			return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
		}
	
		return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
	};

	const handleSaveNeftDetails = async () => {
		//make api call to save details.
		const {
			sNEFTDetails2,
			bNEFTPayment,
			sNEFTTxnId_2,
			fAmountReceived_2 = 0,
		} = neftDetails;

		if (
			fAmountReceived_2 === 0 &&
			sNEFTTxnId_2 &&
			sNEFTDetails2.length > 0
		) {
			toast(`Amount is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			fAmountReceived_2 !== 0 &&
			(sNEFTTxnId_2 === undefined || sNEFTTxnId_2 === "")
		) {
			toast(`Transaction id is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		const payableAmount = computeFinalPayableAmount(selectedServiceRequest);
		// console.log('payableAmount',payableAmount)

		if (payableAmount !== null && Number(fAmountReceived_2) !== Number(payableAmount)) {
			toast(`Amount received must equal payable amount: ₹${payableAmount}`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		} else if (payableAmount == null && Number(fAmountReceived_2) !== Number(selectedServiceRequest?.fAmountSecond)) {
			toast(`Amount received must equal payable amount: ₹${selectedServiceRequest?.fAmountSecond}`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		} else if (payableAmount == null && fAmountReceived_2 == 0 && selectedServiceRequest?.fAmountSecond > 0) {
			toast(`Amount received cannot be 0. Payable amount is ${selectedServiceRequest?.fAmountSecond}.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		} else if (payableAmount == null && fAmountReceived_2 == 0) {
			toast(`Amount received cannot be 0.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		}

		if ((sNEFTDetails2 && sNEFTDetails2.length > 0) || bNEFTPayment) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				setLoader(true);
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetailsSPM({
					sNEFTDetails2,
					bNEFTPayment: true,
					sNEFTTxnId_2,
					fAmountReceived_2,
					nResourceInstanceId,
				});
				updateStatusArray(nResourceInstanceId);
				getServices(tableInstance);
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} catch (error) {
				toast(`Something went wrong. Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setLoader(false);
			} finally {
				toggleNeftModal();
				setLoader(false);
			}
		} else {
			toggleNeftModal();
		}
	};


	const handleSaveNeftDetailsOld = async () => {
		//make api call to save details.
		const {
			sNEFTDetails,
			bNEFTPayment,
			sNEFTTxnId_2,
			fAmountReceived_2 = 0,
		} = neftDetails;

		if (
			fAmountReceived_2 === 0 &&
			sNEFTTxnId_2 &&
			sNEFTDetails.length > 0
		) {
			toast(`Amount is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			fAmountReceived_2 !== 0 &&
			(sNEFTTxnId_2 === undefined || sNEFTTxnId_2 === "")
		) {
			toast(`Transaction id is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		if ((sNEFTDetails && sNEFTDetails.length > 0) || bNEFTPayment) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetailsSPM({
					sNEFTDetails,
					bNEFTPayment: true,
					sNEFTTxnId_2,
					fAmountReceived_2,
					nResourceInstanceId,
				});
				updateStatusArray(nResourceInstanceId);
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} catch (error) {
				toast(`Something went wrong. Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
	};

	/*
	 * Refund modal data
	 */
	const [showRefundModal, setRefundModalVisibility] = useState(false);
	const [refundDetails, setRefundDetails] = useState({});
	const [isLoadingRefund, setIsLoadingRefund] = useState(false);
	const [selectedCancellationReasonForRefund, setSelectedCancellationReasonForRefund] = useState();
	const [enableOtherDescriptionTextboxForRefund, setEnableOtherDescriptionTextboxForRefund] = useState(false);
	const [cancellationReasonOtherDescriptionforRefund, setCancellationReasonOtherDescriptionforRefund] = useState();

	/**
	 * Refund callbacks
	 */
	const toggleRefundModal = (e) => {
		let user = getUser();
		if (e && e["refFacilitator"]) {
			if (
				user.access_rights["SERVICE"] &&
				user.access_rights["SERVICE"].includes("MANAGE") == false
			) {
				toast(`You are not a facilitator.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			if (user.email !== e["refFacilitator"]["email"]) {
				toast("You are not the assigned facilitator.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			if (e["dtRefunded"]) {
				var dtrefund = new Date(e["dtRefunded"]);
			}

			setRefundDetails({
				bRefund: e["bRefund"],
				sRefundComment: e["sRefundComment"],
				dtRefunded: dtrefund,
			});
			setSelectedServiceRequest(e);
		}
		setRefundModalVisibility(!showRefundModal);
	};

	const onRefundDetailsChanged = (name, value) => {
		const updated = { ...refundDetails, [name]: value };

		setRefundDetails(updated);
	};

	const onSaveRefundDetails = async () => {
		const {
			bRefund,
			sRefundComment,
			dtRefunded,
		} = refundDetails;

		if (bRefund) {
			if (!dtRefunded) {
				toast("Refund date is required", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}

			if (!sRefundComment) {
				toast("Refund comment is required", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}

			let sServiceCancellationReason = null, sServiceCancellationReasonOtherDescription = null;
			if (selectedServiceRequest["refCurrentState"]["sServiceState"] !== "Cancelled") {
				if (selectedCancellationReasonForRefund) {
					sServiceCancellationReason = selectedCancellationReasonForRefund.value;
					if (sServiceCancellationReason !== "Other") {
						sServiceCancellationReasonOtherDescription = null;
					}
					else {
						if (cancellationReasonOtherDescriptionforRefund) {
							sServiceCancellationReasonOtherDescription = cancellationReasonOtherDescriptionforRefund;
						}
						else {
							toast("Please specify cancellation reason.", {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							return;
						}
					}
				}
				else {
					toast("Please select cancellation reason.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					return;
				}
			}
			setIsLoadingRefund(true);
			const { nResourceInstanceId } = selectedServiceRequest;
			api.saveRefundDetails({
				bRefund,
				sRefundComment,
				dtRefunded: dtRefunded.toISOString(),
				nResourceInstanceId,
				sServiceCancellationReason,
				sServiceCancellationReasonOtherDescription
			})
				.then((response) => {

					if (response.status == 202) {
						if (response.data.message) {
							toast(response.data.message, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						}
						else {
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
						}
					}
					else {
						if (response.data.message) {
							toast(response.data.message, {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						}
						else {
							toast("Internal server error.", {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
						}
					}

					getServices(tableInstance);
					updateStatusArray(nResourceInstanceId);
					toggleRefundModal();
					setIsLoadingRefund(false);
				})
				.catch((error) => {
					toast(String(error.response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					setIsLoadingRefund(false);
				});
		}
		else {
			toast("Please select is Refunded.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
	};

	const handleExpand = (id) => {
		if (resourceId) {
			setLoader(true);
			setExtendedData([])
			api.getMyServiceRequestsFacilitatorExpand(
				resourceId
			)
				.then((response) => {
					setExtendedData(response.data.results[0]);
					setLoader(false);

				})
				.catch((error) => {
					setLoader(false)
				});
				api.getStateAuditLogSPM(
					resourceId
				).then((d) => {
					if(d.data.length>0){
						setProgressionDate(d.data[0]?.dtCreated);
					}else{
						setProgressionDate('');
					}
				});
		}
	}

	useEffect(() => {
		handleExpand(resourceId)
	}, [resourceId])

	// useEffect(() => {
	// 	if (selectedServiceRequest) {
	// 		const { nResourceInstanceId } = selectedServiceRequest;
	// 		const Interval = setInterval(() => {
	// 			updateStatusArray(nResourceInstanceId);
	// 		}, 10000);
	// 		clearInterval(Interval)	
	// 	}
	// }, [selectedServiceRequest])
	// useEffect(() => {	  
	// 	if (!selectedServiceRequest?.nResourceInstanceId) return;
	  
	// 	const { nResourceInstanceId } = selectedServiceRequest;
	  
	// 	const interval = setInterval(() => {
	// 	  updateStatusArray(nResourceInstanceId);
	// 	}, 10000);
	  
	// 	return () => {
	// 	  clearInterval(interval);
	// 	};
	//   }, [selectedServiceRequest]);
	useEffect(() => {
		if (!selectedServiceRequest?.nResourceInstanceId) return;

		const { nResourceInstanceId } = selectedServiceRequest;

		console.log(
			'showCancellationReasonModal',
			showCancellationReasonModal
		);

		// Don't start polling while cancellation modal is open
		if (showCancellationReasonModal) {
			return;
		}

		// Start polling
		const interval = setInterval(() => {
			updateStatusArray(nResourceInstanceId);
		}, 10000);

		// Cleanup when dependencies change or component unmounts
		return () => {
			clearInterval(interval);
		};
	}, [selectedServiceRequest, showCancellationReasonModal]);

	useEffect(() => {
		setSelectedCancellationReasonForRefund();
		setCancellationReasonOtherDescriptionforRefund();
		if (selectedServiceRequest && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequest.sServiceCancellationReason) {
					setSelectedCancellationReasonForRefund(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescriptionforRefund(
							selectedServiceRequest.sServiceCancellationReasonOtherDescription
						);
					}
				}
			});
		}

	}, [selectedServiceRequest, selectedService]);

	const calculateEnableOtherDescriptionTextboxForRefund = () => {
		if (
			selectedCancellationReasonForRefund &&
			selectedCancellationReasonForRefund.value === "Other"
		)
			setEnableOtherDescriptionTextboxForRefund(true);
		else setEnableOtherDescriptionTextboxForRefund(false);
	};

	useEffect(() => {
		calculateEnableOtherDescriptionTextboxForRefund();
	}, [selectedCancellationReasonForRefund]);

	/**
	 * Notes data
	 */

	const [showNotesModal, setNotesModalVisibility] = useState(false);
	const [notesDetails, setNotesDetails] = useState({});
	const [notesHistory, setNotesHistory] = useState([]);
	const [currentNote, setCurrentNote] = useState({});
	const [auditTrail, setAuditTrail] = useState({});

	const [showConfirmationModal, setShowConfirmationModal] = useState(false);

	/**

	/**
	 * Notes Modal Callbacks
	 * 
	 * 
	 */

	const changeSelectedNotesDetails = (direction) => {
		if (notesHistory.length === 0) return;

		//sFollowupAction dtFollowupOn sNotes
		let currentNoteIndex;
		if (isEmpty(currentNote) == true && direction === "next") {
			setNotesDetails({
				sFollowupAction: "",
				dtFollowupOn: "",
				sNotes: "",
				bHandled: false,
				currentNoteIndex: -1,
			});
			return;
		}
		if (isEmpty(currentNote) == true && direction === "previous") {
			currentNoteIndex = notesHistory.length - 1;
			setCurrentNote(notesHistory[currentNoteIndex]);
			setNotesDetails({});
			setNotesDetails({
				currentNoteIndex: currentNoteIndex,
				sFollowupAction:
					notesHistory[currentNoteIndex]["sFollowupAction"],
				dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
				bHandled: notesHistory[currentNoteIndex]["bHandled"],
				sNotes: notesHistory[currentNoteIndex]["sNotes"],
			});
			return;
		}
		notesHistory.map((e, i) => {
			if (currentNote["id"] === e["id"]) {
				currentNoteIndex = i;
			}
		});

		if (direction === "previous" && currentNoteIndex > 0) {
			currentNoteIndex -= 1;
			setCurrentNote(notesHistory[currentNoteIndex]);
			setNotesDetails({});
			setNotesDetails({
				currentNoteIndex: currentNoteIndex,
				sFollowupAction:
					notesHistory[currentNoteIndex]["sFollowupAction"],
				dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
				sNotes: notesHistory[currentNoteIndex]["sNotes"],
				bHandled: notesHistory[currentNoteIndex]["bHandled"],
			});
			return;
		}
		if (
			direction === "next" &&
			currentNoteIndex < notesHistory.length - 1
		) {
			currentNoteIndex += 1;
			setCurrentNote(notesHistory[currentNoteIndex]);
			setNotesDetails({});
			setNotesDetails({
				currentNoteIndex: currentNoteIndex,
				sFollowupAction:
					notesHistory[currentNoteIndex]["sFollowupAction"],
				dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
				sNotes: notesHistory[currentNoteIndex]["sNotes"],
				bHandled: notesHistory[currentNoteIndex]["bHandled"],
			});
			return;
		}

		if (
			direction === "next" &&
			currentNoteIndex === notesHistory.length - 1
		) {
			setCurrentNote({});
			setNotesDetails({
				sFollowupAction: "",
				dtFollowupOn: "",
				sNotes: "",
				bHandled: false,
				currentNoteIndex: -1,
			});
			return;
		}
	};

	const toggleConfirmationModalNotes = () => {
		setShowConfirmationModal(!showConfirmationModal);
	};

	const confirmChangeNotes = () => {
		setSelectedServiceRequest("");
		setNotesDetails({});
		setNotesModalVisibility(!showNotesModal);
		toggleConfirmationModalNotes();
		setCurrentNote({});

	};

	//  Feedback Modal
	const [showFeedbackModal, setshowFeedbackModalVisibility] = useState(false);

	const toggleShowFeedbackModal = () => {
		setshowFeedbackModalVisibility(!showFeedbackModal);
	}
	//*//



	const toggleNotesModal = async (e) => {

		if (selectedServiceRequest) {

			if (
				notesDetails["currentNoteIndex"] !== -1 &&
				(notesDetails["dtFollowupOn"] !== currentNote["dtFollowupOn"] ||
					notesDetails["sNotes"] !== currentNote["sNotes"] ||
					notesDetails["sFollowupAction"] !==
					currentNote["sFollowupAction"] ||
					notesDetails["bHandled"] !== currentNote["bHandled"]
					//notesDetails["bOfflineMeet"] !== currentNote["bOfflineMeet"]
				)
			) {
				if (showNotesModal === true && (notesDetails["dtFollowupOn"] !== "" || notesDetails["sNotes"] !== "" || notesDetails["sFollowupAction"] !== "" || notesDetails["bHandled"] !== false)) {
					toggleConfirmationModalNotes()
				}
				else {
					setNotesModalVisibility(!showNotesModal);
				}
				return;
			} else {
				setSelectedServiceRequest("");
				setNotesDetails({});
				setCurrentNote({});
				setNotesHistory({});
				setNotesModalVisibility(!showNotesModal);
			}
		} else {
			let data = await api
				.getNotesHistory({
					nResourceInstanceId: e["nResourceInstanceId"],
				})
				.then((f) => {
					setNotesHistory(f.data);
				});

			/*let data1 = await api
				.getAuditTrailNotesSPM({
					nResourceInstanceId: e["nResourceInstanceId"],
				})
				.then((f1) => {
					setAuditTrail(f1);
				});*/

			let payload = { nResourceInstanceId: e["nResourceInstanceId"] };
			api.getESPNotesLogByServiceId(payload).then(({ data }) => {
				setAuditTrail(data);
			});


			if (e.bNeedToTalkToSP) {
				setSelectedNeedToTalkToSPOption({
					value: true,
					label: "Yes",
				})
			}
			else {
				setSelectedNeedToTalkToSPOption({
					value: false,
					label: "No",
				})
			}


			if (e.bOfflineMeet == true) {
				setselectedofflinemeetoptions({
					value: true,
					label: "Opted",

				})
			}
			else {

				setselectedofflinemeetoptions({
					value: false,
					label: "Not Opted",
				})
			}


			setSelectedServiceRequest(e);
			setNotesModalVisibility(!showNotesModal);

		}
	};

	const onNotesChange = (name, value) => {
		const updated = {
			...notesDetails,
			[name]: value,
		};
		setNotesDetails(updated);
	};




	const onSaveNotesDetails = async () => {
		if (
			notesDetails["sNotes"] === "" ||
			notesDetails["sNotes"] === undefined ||
			notesDetails["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(notesDetails["dtFollowupOn"] && notesDetails["sFollowupAction"])
		) {
			if (
				(notesDetails["sFollowupAction"] === "" ||
					notesDetails["sFollowupAction"] === null ||
					notesDetails["sFollowupAction"] === undefined) &&
				(notesDetails["dtFollowupOn"] === "" ||
					notesDetails["dtFollowupOn"] === undefined ||
					notesDetails["dtFollowupOn"] === null)
			) {
			} else if (
				notesDetails["dtFollowupOn"] === "" ||
				notesDetails["dtFollowupOn"] === undefined ||
				notesDetails["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				notesDetails["sFollowupAction"] === "" ||
				notesDetails["sFollowupAction"] === undefined ||
				notesDetails["sFollowupAction"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {

			let bNeedToTalkToSPnew = selectedNeedToTalkToSPOption.value;
			const { bNeedToTalkToSP } = selectedServiceRequest;
			if (bNeedToTalkToSPnew != bNeedToTalkToSP) {
				onUpdateNeedToTalkToSPFlag();
			}



			let bOfflineMeetnew = selectedofflinemeetoptions.value;
			const { bOfflineMeet } = selectedServiceRequest;
			if (bOfflineMeetnew != bOfflineMeet) {
				onUpdateOfflineMeetoptions();
			}



			if (isEmpty(currentNote)) {
				let data = await api
					.saveNotes({
						...notesDetails,
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then(() => {
						setSelectedServiceRequest("");
						setNotesDetails({});
						setCurrentNote({});
						setNotesHistory({});
						setNotesModalVisibility(false);


					});

				/*let data1 = await api
					.getAuditTrailNotesSPM({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f1) => {
						setAuditTrail(f1);
					});
				let data2 = await api
					.getNotesHistory({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f) => {
						setNotesHistory(f.data);
					})
					.catch((error) => {
						toast(String(error.response.statusText), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});

				setNotesDetails({
					sFollowupAction: "",
					dtFollowupOn: "",
					sNotes: "",
					bHandled: false,
				});
				setCurrentNote({});*/
			} else {
				if (
					notesDetails["dtFollowupOn"] ===
					currentNote["dtFollowupOn"] &&
					notesDetails["sNotes"] === currentNote["sNotes"] &&
					notesDetails["sFollowupAction"] ===
					currentNote["sFollowupAction"] &&
					notesDetails["bHandled"] === currentNote["bHandled"]


				) {
					toast("No changes made", {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
					return;
				}
				let data = await api
					.updateNotes({
						...notesDetails,
						id: currentNote["id"],
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((d) => {
						setNotesDetails({
							sFollowupAction: d.data["sFollowupAction"],
							dtFollowupOn: d.data["dtFollowupOn"],
							sNotes: d.data["sNotes"],
							bHandled: d.data["bHandled"],
						});
					})

					.catch((error) => {
						toast(String(error.response.statusText), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});
				/*let data2 = await api
					.getAuditTrailNotesSPM({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f1) => {
						setAuditTrail(f1);
					});*/
				let payload = { nResourceInstanceId: selectedServiceRequest["nResourceInstanceId"] };
				api.getESPNotesLogByServiceId(payload).then(({ data }) => {
					setAuditTrail(data);
				});



				let data1 = await api
					.getNotesHistory({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f) => {
						setNotesHistory(f.data);
						f.data.map((e, i) => {
							if (currentNote["id"] === e["id"]) {
								setCurrentNote(e);
								setNotesDetails({
									...notesDetails,
									currentNoteIndex: i,
								});
							}
						});
					})
					.catch((error) => {
						toast(String(error.response.statusText), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});
			}
			// toggleNotesModal();
			// toggleNotesModal();

			toast("Note saved successfully.", {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
		} catch (error) {
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	/** Payment link API */

	const sendPaymentLinkSPM = (e) => {
		let user = getUser();
		if (
			user.access_rights["SERVICE"] &&
			user.access_rights["SERVICE"].includes("MANAGE") == false
		) {
			toast(`You are not a facilitator.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		if (user.email !== e["refFacilitator"]["email"]) {
			toast("You are not the assigned facilitator.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setIsLoadingStateChange(true);

		let data = api.sendPaymentLinkSPM({ nResourceInstanceId: e["nResourceInstanceId"], })
			.then((d) => {
				if (d.data.message.status_code === "0") {
					api.setFullPaymentRequested({
						nResourceInstanceId: e["nResourceInstanceId"],
					})
						.then(() => {
							toast("Payment link sent successfully", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(e["nResourceInstanceId"]);
							setIsLoadingStateChange(false);

							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});
				}else if (d.data.message.status === "error" && d.data.message.message === "Updating LS record failed" || d.data.message.message === "Payment link is active. But, error in updating details to LS" || d.data.message.message === "'data'") {
					api.setFullPaymentRequested({
						nResourceInstanceId: e["nResourceInstanceId"],
					})
						.then(() => {
							toast("Payment link sent successfully", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(e["nResourceInstanceId"]);
							setIsLoadingStateChange(false);

							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});
				} else {
					toast(String(d.data.message.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					setIsLoadingStateChange(false);
				}
			})
			.catch((error) => {
				toast(String(error.response.data.detail), {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoadingStateChange(true);
			});
	};

	/**Service Partner */

	const [servicePartnerList, setServicePartnerList] = useState([]);
	const [externalServicePartnerList, setExternalServicePartnerList,] = useState([]);

	const [currentServicePartner, setCurrentServicePartner] = useState();
	const [currentExternalServicePartner, setCurrentExternalServicePartner,] = useState();

	const [showServicePartnerModal, setShowServicePartnerModal] = useState(false);

	const [showExternalServicePartnerModal, setShowExternalServicePartnerModal,] = useState(false);

	const toggleServicePartnerModal = (e) => {
		if (selectedServiceRequest) {
			setSelectedServiceRequest("");
			setCurrentServicePartner("");
			let temp = servicePartnerList.map((f) => {
				f["checked"] = false;
				return f;
			});
			setServicePartnerList(temp);
		} else {
			setSelectedServiceRequest(e);
			setCurrentServicePartner(
				e["refServicePartner"]
					? e["refServicePartner"]["email"]
					: e["refServicePartner"]
			);
			if (e["refServicePartner"]) {
				let temp = servicePartnerList.map((f) => {
					if (f["id"] === e["refServicePartner"]["email"]) {
						f["checked"] = true;
					} else {
						f["checked"] = false;
					}
					return f;
				});
				setServicePartnerList(temp);
			}
		}

		setShowServicePartnerModal(!showServicePartnerModal);
	};

	const toggleExternalServicePartnerModal = async (e) => {
		let externalSP;
		if (e) {
			setIsLoading(true);
		const serviceInfo =	await api.getMyServiceRequestsFacilitatorExpand(
			e['nResourceInstanceId']
		)
			let temp = api
				.getExternalServicePartners({
					sServiceCode: e["sServiceCode"],
				})
				.then((d) => {
					let externalServicePartners = d.data.map((f) => {
						let flag = false;

						if (
							e["refExternalServicePartner"] &&
							f["sName"] ===
							e["refExternalServicePartner"][
							"sName"
							]
						) {
							flag = true;
						} else {
							flag = false;
						}

						return {
							checked: flag,
							label: f["sName"],
							id: f["sServicePartnerEmail"],
							code: f["sServicePartnerEmail"],
							uniqueId: f["id"]
						};
					});
					const filteredData = externalServicePartners
						? externalServicePartners.filter(item => item.uniqueId !== 66)
						: [];
					const filteredDataOnlySudhir = externalServicePartners
						? externalServicePartners.filter(item => item.uniqueId === 66)
						: [];

					const result = serviceInfo?.data?.results?.[0];
					const paymentReceiver = result?.sPaymentReceiver;
					const nPackageInstanceId = result?.nPackageInstanceId;
					const sPackageOfferTitle = result?.sPackageOfferTitle;

					const partnerEmail =
						typeof result?.refExternalServicePartner === "object"
							? result?.refExternalServicePartner?.sServicePartnerEmail
							: result?.refExternalServicePartner;

					if (paymentReceiver === "Partner" && (nPackageInstanceId == null || sPackageOfferTitle ==='Long Term Engagement Package' || sPackageOfferTitle ==='Long Term Engagement Package1')) {
						if (partnerEmail === "gijare@deasra.co.in") {
							setExternalServicePartnerList(filteredDataOnlySudhir);
						} else {
							setExternalServicePartnerList(filteredData);
						}
					} else {
						setExternalServicePartnerList(externalServicePartners);
					}
					setIsLoading(false);
				});
		}

		if (selectedServiceRequest) {
			setSelectedServiceRequest("");
			setCurrentExternalServicePartner("");
			let temp = externalServicePartnerList.map((f) => {
				f["checked"] = false;
				return f;
			});
			setExternalServicePartnerList(temp);
		} else {
			setSelectedServiceRequest(e);
			setCurrentExternalServicePartner(
				e["refExternalServicePartner"]
					? e["refExternalServicePartner"]["sServicePartnerEmail"]
					: e["refExternalServicePartner"]
			);

			if (e["refExternalServicePartner"]) {
				let temp = externalServicePartnerList.map((f) => {
					if (
						f["id"] ===
						e["refExternalServicePartner"]["sServicePartnerEmail"]
					) {
						f["checked"] = true;
					} else {
						f["checked"] = false;
					}
					return f;
				});
				setExternalServicePartnerList(temp);
			}
		}
		setShowExternalServicePartnerModal(!showExternalServicePartnerModal);
	};

	const toggleServicePartner = (servicePartnerEmail) => {
		let temp = servicePartnerList.map((f) => {
			if (f["id"] === servicePartnerEmail) {
				f["checked"] = true;
			} else {
				f["checked"] = false;
			}
			return f;
		});
		setServicePartnerList(temp);
	};

	const toggleExternalServicePartner = (externalServicePartnerEmail) => {

		let temp = externalServicePartnerList.map((f) => {
			if (f["uniqueId"] == externalServicePartnerEmail) {
				f["checked"] = true;
			} else {
				f["checked"] = false;
			}
			return f;
		});
		setExternalServicePartnerList(temp);
	};

	const saveServicePartner = (e, clear = false) => {
		let user = getUser();
		if (
			user.access_rights["SERVICE"] &&
			user.access_rights["SERVICE"].includes("MANAGE") == false
		) {
			toast(`You are not a facilitator.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		let sp;
		let nResourceInstanceId;
		if (clear) {
			sp = "";
			nResourceInstanceId = e["nResourceInstanceId"];
		} else {
			sp = servicePartnerList.filter((e) => e.checked === true)[0]["id"];
			nResourceInstanceId = selectedServiceRequest["nResourceInstanceId"];
		}

		try {
			let temp = api
				.saveServicePartner({
					nResourceInstanceId: nResourceInstanceId,
					ServicePartner: sp,
				})
				.then(() => {
					if (clear === false) toggleServicePartnerModal();
					setSelectedServiceRequest("");
					setCurrentServicePartner("");
					getServices(tableInstance);

					// window.location.reload(false);
					if (clear) {
						toast("Service Partner cleared successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					} else {
						toast("Service Partner saved successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				});
		} catch (error) {
			toast(String(error.response.data.detail), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const saveExternalServicePartner = (e, clear = false) => {
		let user = getUser();
		if (
			user.access_rights["SERVICE"] &&
			user.access_rights["SERVICE"].includes("MANAGE") == false
		) {
			toast(`You are not a facilitator.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		let sp;
		let nResourceInstanceId;

		if (clear) {
			sp = "";
			nResourceInstanceId = e["nResourceInstanceId"];
		} else {
			sp = externalServicePartnerList.filter(
				(e) => e.checked === true
			)[0]["label"];
			nResourceInstanceId = selectedServiceRequest["nResourceInstanceId"];
		}

		try {
			let temp = api
				.saveServicePartner({
					nResourceInstanceId: nResourceInstanceId,
					ExternalServicePartner: sp,
				})
				.then((d) => {
					if (clear === true) {
						toast(
							"External Service Partner cleared successfully.",
							{
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							}
						);
					} else {
						toast(
							"External Service Partner assigned successfully.",
							{
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							}
						);
					}

					if (clear === false) toggleExternalServicePartnerModal();
					setSelectedServiceRequest("");
					setCurrentExternalServicePartner("");
					getServices(tableInstance);
					// window.location.reload(false);
				})
				.catch((error) => {
					toast(String(error.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			toast(String(error.response.data.detail), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};


	/**
	 * Status changes
	 */
	// const [statusList, setStatusList] = useState([
	// 	"Ready For Progression",
	// 	"Payment Confirmed By Partner",
	// 	"Awaiting For Information/Documents",
	// 	"Service Delivery Start",
	// 	"Service Deliverables ready",
	// 	"Full Payment Requested",
	// 	"Full Payment Received",
	// 	"Delivered",
	// 	"Cancelled",
	// ]);

	const [statusList, setStatusList] = useState([
		"Ready For Progression",
		"Awaiting for information/Documents",
		"Info & Docs Received",
		"Payment Confirmed By Partner",
		"Service Delivery Started",
		"Service deliverables ready",
		"Full Payment Requested",
		"Full Payment Received",
		"Delivered",
		"Cancelled",
		"Refunded"
	]);

	const updateStatusArray = async (instance_id) => {
		try {
			const { data } = await api.searchServiceById(instance_id);
			console.log("Status Data=", data)
			let temp = createStatusArray(data);
			setSelectedServiceRequest(temp);
			console.log("Service Update", temp)
		} catch (err) {
			console.log("Error in updating Status Array", err);
		}
	};

	const [isLoadingStateChange, setIsLoadingStateChange] = useState(false);

	const chanegState = (statusObj) => {
		let data = {
			nResourceInstanceId: statusObj["service"]["nResourceInstanceId"],
		};

		let user = getUser();
		setIsLoadingStateChange(true);
		try {
			switch (statusObj["statusName"]) {
				case "serviceDeliveryStarted":
					/*if (!statusObj["service"]["refServicePartner"]) {
						setIsLoadingStateChange(false);
						toast("Service Partner not assigned.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (user.email !==statusObj["service"]["refServicePartner"]["email"]) {
						setIsLoadingStateChange(false);
						toast("You are not the assigned service partner.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}*/
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["DELIVER"] ==
						false
					) {
						setIsLoadingStateChange(false);
						toast("You are not a service partner.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDeliveryStarted(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "paymentConfirmedByPartner":
					api.setPaymentConfirmedbyPartner(data)
						.then((response) => {
							getServices(tableInstance);

							if (response.status == 202) {
								if (response.data.message) {
									toast(response.data.message, {
										autoClose: 5000,
										type: toast.TYPE.SUCCESS,
									});
								}
								else {
									toast("Service updated successfully.", {
										autoClose: 5000,
										type: toast.TYPE.SUCCESS,
									});
								}
							}
							else {
								if (response.data.message) {
									toast(response.data.message, {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								}
								else {
									toast("Internal server error.", {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								}
							}
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "AwaitingForInformationDocuments":
					api.setAwaitingForInformationDocuments(data)
						.then((response) => {
							getServices(tableInstance);
							if (response.status == 202) {
								if (response.data.message) {
									toast(response.data.message, {
										autoClose: 5000,
										type: toast.TYPE.SUCCESS,
									});
								}
								else {
									toast("Service updated successfully.", {
										autoClose: 5000,
										type: toast.TYPE.SUCCESS,
									});
								}
							}
							else {
								if (response.data.message) {
									toast(response.data.message, {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								}
								else {
									toast("Internal server error.", {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								}
							}
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;

					case "InfoandDocsReceived":
					api.setInfoDocsReceived(data)
						.then((response) => {
							getServices(tableInstance);
							if (response.status == 202) {
								if (response.data.message) {
									toast(response.data.message, {
										autoClose: 5000,
										type: toast.TYPE.SUCCESS,
									});
								}
								else {
									toast("Service updated successfully.", {
										autoClose: 5000,
										type: toast.TYPE.SUCCESS,
									});
								}
							}
							else {
								if (response.data.message) {
									toast(response.data.message, {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								}
								else {
									toast("Internal server error.", {
										autoClose: 5000,
										type: toast.TYPE.ERROR,
									});
								}
							}
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;

				case "serviceDeliverablesReady":
					// if (!statusObj["service"]["refServicePartner"]) {
					// 	toast("Service Partner not assigned", {
					// 		autoClose: 5000,
					// 		type: toast.TYPE.ERROR,
					// 	});
					// 	return;
					// }
					// if (
					// 	user.email !==
					// 	statusObj["service"]["refServicePartner"]["email"]
					// ) {
					// 	toast("You are not the assigned service partner", {
					// 		autoClose: 5000,
					// 		type: toast.TYPE.ERROR,
					// 	});
					// 	return;
					// }
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["DELIVER"] ==
						false
					) {
						toast("You are not a service partner", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDeliverablesReady(data)
						.then((d) => {
							getServices(tableInstance);
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							setIsLoadingStateChange(false);

							// let temp = createStatusArray(d.data);
							// console.log("selected service changed to", temp);
							// setSelectedService(temp);
							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "requestFullPayments":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
						false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setFullPaymentRequested(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// document.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "fullPaymentReceived":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
						false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setFullPaymentComplete(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// document.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "delivered":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
						false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDelivered(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// window.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "cancelled":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
						false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						statusObj["service"]["refCurrentState"][
						"sServiceState"
						] === "Delivered"
					) {
						toast("A delivered service can not be cancelled", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					let cancellation_Reason, OtherDescription;
					if (selectedCancellationReason) {
						cancellation_Reason = selectedCancellationReason.value;
						if (cancellation_Reason !== "Other")
							OtherDescription = null;
						else
							OtherDescription = cancellationReasonOtherDescription;
					}

					api.setServiceCancelled({
						...data,
						cancellationReason: cancellation_Reason,
						cancellationReasonOtherDescription: OtherDescription,
					})
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							toggleCancellationReasonModal();
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				default:
					break;
			}

			// console.log("data === >", data);
			// toast("Status changed successfully.", {
			//   autoClose: 5000,
			//   type: toast.TYPE.SUCCESS,
			// });
		} catch (error) {
			toast(String(error.response.data.message), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	/**
	 * pagination states
	 */
	const [pages, setPages] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const [currentPage, setcurrentPage] = useState(0);
	const [tableInstance, setTableInstance] = useState(null);
	const history = useHistory();
	//const [count, setCount ] = useState(0);
	const [searchTerm, setSearchTerm] = useState();
	const [pageSizeOptions, setpageSizeOptions] = useState([
		{
			value: "10",
			label: "10 Rows",
		},
		{
			value: "20",
			label: "20 Rows",
		},
		{
			value: "30",
			label: "30 Rows",
		},
		{
			value: "50",
			label: "50 Rows",
		},
		{
			value: "75",
			label: "75 Rows",
		},
		{
			value: "100",
			label: "100 Rows",
		},
	]);
	const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
		value: "10",
		label: "10",
	});


	useEffect(() => {
		// getServices(tableInstance, true);
		setSelectedServiceRequest("");
	}, [selectedPageSizeOption]);




	const createStatusArray = (d) => {
		let tempStatusArray = [];
		// const lower = statusList.map(element => {
		// 	return element.toLowerCase();
		//   });
		  
		if (statusList.indexOf(d["refCurrentState"]["sServiceState"]) >= 0) {
			for (let i = 0; i < 11; i++) {
				if (d["refCurrentState"]["sServiceState"] === "Cancelled") {
					tempStatusArray.push("disable");
				}
				else {
					if (i <= statusList.indexOf(d["refCurrentState"]["sServiceState"])) {
						tempStatusArray.push("status-reached");
					}
					else if (i == statusList.indexOf(d["refCurrentState"]["sServiceState"]) + 1) {
						tempStatusArray.push("");
					}
					else {
						tempStatusArray.push("disable");
					}
				}
			}
			if (d["sPaymentMode"] === "1_Step_Payment") {
				// tempStatusArray[5] = "disable";
				// tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] === "Service deliverables ready")
					tempStatusArray[8] = "";
			}

			if (d["sPaymentMode"] === "2_Step_Payment" && d["sNEFTTxnId_2"] !== null) {
				if (d["refCurrentState"]["sServiceState"] === "Full Payment Requested"){
					tempStatusArray[8] = "";
				}
					
			}

			if (d["sPaymentMode"] === "No_Payment" || d['sPaymentReceiver'] === "Partner") {
				// tempStatusArray[5] = "disable";
				// tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] === "Service deliverables ready")
					tempStatusArray[8] = "";
			}
			tempStatusArray[9] = "";
			tempStatusArray[10] = "";
			if (d["refCurrentState"]["sServiceState"] === "Delivered") {
				// tempStatusArray[0] = "disable";
				// tempStatusArray[1] = "disable";
				// tempStatusArray[2] = "disable";
				// tempStatusArray[3] = "disable";
				// tempStatusArray[4] = "disable";
				// tempStatusArray[5] = "disable";
				tempStatusArray[9] = "disable";
				tempStatusArray[10] = "disable";
			}

			// if (d["refCurrentState"]["sServiceState"] === "Awaiting for information/Documents") {
			// 	tempStatusArray[0]= "ahead";
			// 	tempStatusArray[1]= "status-reached";
			// 	tempStatusArray[2]= "";
			// }


			if (d["refCurrentState"]["sServiceState"] === "Cancelled")
			{
				tempStatusArray[9] = "status-reached";
			}

			if (d["refCurrentState"]["sServiceState"] === "Refunded")
			{
				tempStatusArray[10] = "status-reached";
			}

			if (d["sPaymentMode"] === "SP_paid_service" || d['sPaymentReceiver'] === "Partner") {

				// if (d["refCurrentState"]["sServiceState"] === "Payment Confirmed by Partner") {
				// 	// tempStatusArray[3] = "status-ready";
				// 	// tempStatusArray[4] = "";
				// 	// tempStatusArray[5] = "disable";
				// 	// tempStatusArray[7] = "";
				// 	// tempStatusArray[7] = "disable";
				// 	tempStatusArray[0] = "status-ready";
				// 	tempStatusArray[1] = "status-ready";
				// 	tempStatusArray[2] = "status-ready";
				// 	tempStatusArray[3] = "status-ready";
				// 	tempStatusArray[4] = "status-ready";
				// 	tempStatusArray[5] = "";
				// 	tempStatusArray[6] = "disable";
					// tempStatusArray[7] = "";
				// }

				if (d["refCurrentState"]["sServiceState"] ==="Service deliverables ready" && d["sPaymentMode"] === "2_Step_Payment" && d['refExternalServicePartner']?.id === 66)
				{
					tempStatusArray[8] = "disable";
				}else if(d["refCurrentState"]["sServiceState"] ==="Service deliverables ready"){
					tempStatusArray[8] = "";

				}

				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression")
				{
					tempStatusArray[1]="";
				}
				// else if(d["refCurrentState"]["sServiceState"]==="Awaiting for information/Documents") {
				// 	tempStatusArray[1]="status-reached";
				// 	tempStatusArray[2]="";
				// }
				else if(d["refCurrentState"]["sServiceState"]==="Info & Docs Received" && d["sPaymentMode"] === "1_Step_Payment") {
					tempStatusArray[2]="status-reached";
					tempStatusArray[3]="disable";
					tempStatusArray[4]="";
				}else if(d["refCurrentState"]["sServiceState"]==="Info & Docs Received" && d["sPaymentMode"] === "2_Step_Payment" && d['refExternalServicePartner']?.id === 66) {
					tempStatusArray[2]="status-reached";
					tempStatusArray[3]="disable";
					tempStatusArray[4]="";
				}else if(d["refCurrentState"]["sServiceState"]==="Info & Docs Received" && d["sPaymentMode"] === "SP_paid_service") {
					tempStatusArray[2]="status-reached";
					tempStatusArray[3]="";
				}else
				{
					tempStatusArray[1]="status-reached";
					// tempStatusArray[2]="";
					// tempStatusArray[3]="";

				}
			}
			else {
				tempStatusArray[3] = "disable";
				if (d["refCurrentState"]["sServiceState"] === "Ready For Progression") {
					tempStatusArray[1] = "";
				}
				if (d["refCurrentState"]["sServiceState"] === "Info & Docs Received") {
					tempStatusArray[3] = "disable";
					tempStatusArray[4] = "";
				}
			}

			if (d["refCurrentState"]["sServiceState"] === "Cancelled")
			{
				tempStatusArray[0] ="disable";
				tempStatusArray[1] ="disable";
				tempStatusArray[2] ="disable";
				tempStatusArray[3] ="disable";	
				tempStatusArray[4] ="disable";
				tempStatusArray[5] ="disable";
				tempStatusArray[8] ="disable";
				tempStatusArray[9] ="status-reached";
				tempStatusArray[10] = "disable";
			}

			if(d["nPackageInstanceId"])
			{
				tempStatusArray[3] ="disable";
				// tempStatusArray[5] ="disable";
				// tempStatusArray[6] ="disable";
				if (d["refCurrentState"]["sServiceState"] === "Info & Docs Received") {
					tempStatusArray[3] = "disable";
					tempStatusArray[4] = "";
				}

				// if(d["refCurrentState"]["sServiceState"]==="Ready For Progression"||
				// d["refCurrentState"]["sServiceState"]==="Payment Confirmed by Partner")
				// {
				// 	tempStatusArray[1]="";
					
				// }

				if (d["refCurrentState"]["sServiceState"] ==="Service deliverables ready")
				{
					tempStatusArray[8] = "";
				}
			}

			if (d["bCouponApplied"]&&(d["fAmountSecond"]<=d["fDiscountAmount"]) || d["bCouponApplied"]&&(d["fAmountSecond"]<=(d["fDiscountAmount"] + (d["fDiscountAmount"] * 0.18))))
			{
				// tempStatusArray[5] = "disable";
				// tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service deliverables ready")
				{
					tempStatusArray[8] = "";
				}
			}
		}
		console.log("Update=", tempStatusArray)
		d["statusArray"] = tempStatusArray;

		return d;
	};

	const onSearchClicked = () => {
		getServices(tableInstance);
	};

	const onClearAllClicked = () => {
		setDateFilter({
			value: "dtServiceProgression",
			label: "Progression On",
		});
		setCustomerFilterValue("");
		setFromDate("");
		setToDate("");

		setSelectedServiceNameListForFilter([]);
		setSelectedServiceStatusListForFilter([]);
		setSelectedPackageNameListForFilter([]);

		setSelectedIntroductoryConversationOption(null);
		setSelectedCallStatusOption(null);
		setSelectedStayEnagegedOption(null);
		setSelecteduserSharedChallegesGoalsOption(null);
		setSelecteddeAsraAbleHelpforChallegesGoalsOption(null);
		setClearCount(clearCount + 1);
	};

	const [customerFilterOptions, setCustomerFilterOptions] = useState([
		{
			value: "C_name",
			label: "Customer Name",
		},
		{
			value: "C_email",
			label: "Customer Email",
		},
	]);

	const [customerFilter, setCustomerFilter] = useState();

	const onCustomerFilterChange = (e) => {
		setCustomerFilter(e);
	};

	const [customerFilterValue, setCustomerFilterValue] = useState();
	const onCustomerFilterValueChange = (e) => {
		setCustomerFilterValue(e.target.value);
	};

	const [showSendNeftDetailsModal, onSetShowSendNeftDetailsModal] = useState(false);

	const [neftPaymentDetails, onSetNeftPaymentDetails] = useState({});

	const [nResourceInstanceId, setnResourceInstanceId] = useState();
	const [isLoadingSpinnerForMyProgression, setIsLoadingSpinnerForMyProgression] = useState(true);


	const setShowSendNeftDetailsModal = (data, nResourceInstanceId) => {
		onSetShowSendNeftDetailsModal(data);
		setnResourceInstanceId(nResourceInstanceId);
		if (data) {
			api.getNeftAccountDetails().then(({ data }) => {
				onSetNeftPaymentDetails(data);
			});
		}
	};

	const onClickSendNeftAccountDetails = () => {
		api.sendNeftAccountDetails({
			sEmailAddress: selectedServiceRequest["sEmailAddress"],
			nResourceInstanceId: nResourceInstanceId
		})
			.then(({ data }) => {
				onSetShowSendNeftDetailsModal(false);
				toast(data["details"], {
					autoClose: 3000,
					type: toast.TYPE.SUCCESS,
				});
			})
			.catch((e) => {
				onSetShowSendNeftDetailsModal(true);
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 3000,
					type: toast.TYPE.ERROR,
				});
			});
	};


// Utility Functions
const extractValues = (list, excludeWildcard = true) =>
	list.filter(e => !excludeWildcard || e.value !== "*").map(e => e.value);
  
  const adjustToDate = (date) => {
	if (!date) return null;
	const adjusted = new Date(date);
	return new Date(adjusted.setTime(adjusted.getTime() + 24 * 60 * 60 * 1000 - 1000));
  };
  
  const getSortParams = (sorted) => {
	if (!sorted?.length) return null;
	const { id, desc } = sorted[0];
	return { column: id, desc };
  };
  
  const buildStatusArray = (d, statusList) => {
	const currentState = d?.refCurrentState?.sServiceState || "";
	const statusIndex = statusList.indexOf(currentState);
	const arr = Array(11).fill("disable");
  
	if (statusIndex >= 0) {
	  for (let i = 0; i < 11; i++) {
		if (currentState === "Cancelled") {
		  arr[i] = "disable";
		} else if (i <= statusIndex) {
		  arr[i] = "status-reached";
		} else if (i === statusIndex + 1) {
		  arr[i] = "";
		}
	  }
  
	  arr[9] = "";
	  arr[10] = "";
	  if (currentState === "Delivered") arr[9] = arr[10] = "disable";
	  if (currentState === "Cancelled") arr[9] = "status-reached";
	  if (currentState === "Refunded") arr[10] = "status-reached";
  
	  if (["2_Step_Payment", "SP_paid_service"].includes(d.sPaymentMode) || ["Partner"].includes(d.sPaymentReceiver)) {
		if (currentState === "Full Payment Requested" && d.sNEFTTxnId_2) arr[8] = "";
		if (currentState === "Service deliverables ready") arr[8] = "";
	  }
  
	  if (d.bCouponApplied && d.fAmountSecond <= d.fDiscountAmount) {
		if (currentState === "Service deliverables ready") arr[8] = "";
	  }
  
	  if (d.nPackageInstanceId) {
		arr[3] = "disable";
		if (currentState === "Info & Docs Received") arr[4] = "";
	  }
  
	  if (currentState === "Ready For Progression") arr[1] = "";
	  else if (d.sPaymentMode === "SP_paid_service" || d.sPaymentReceiver === "Partner") arr[1] = "status-reached";
	}
  
	return arr;
  };
  
  const getServices = (instance, flag = null, pageSizes) => {
	setLoader(true)
	return new Promise((resolve, reject) => {
	  try {
		if (!instance) return resolve();
		if (!getUser()) {
		  history.push("/login");
		  return resolve();
		}
  
		if (!tableInstance) setTableInstance(instance);
		fetchallCatalogs();
		setUser(getUser());
		setTableDataType("serviceRequests");

  
		const icurrentPage = !flag && !isNaN(instance?.state?.page) ? instance.state.page : 0;
		const pageSize = pageSizes ? pageSizes : selectedPageSizeOption?.value || 10;
		const sortParams = getSortParams(instance?.state?.sorted);
		const toDateAdjusted = adjustToDate(toDate);
  
		const selectedServiceNames = extractValues(selectedServiceNameListForFilter);
		const PackageList = extractValues(selectedPackageNameListForFilter);
		const serviceStatusList = extractValues(selectedServiceStatusListForFilter);
  
		const filters = {
		  IntroductoryCall: selectedIntroductoryConversationOption?.value ?? null,
		  CallConnectedStatus: selectedCallStatusOption?.value ?? null,
		  EngagementCallStayEngaged: selectedStayEnagegedOption?.value ?? null,
		  DoesUserSharedChallenges: selecteduserSharedChallegesGoalsOption?.value ?? null,
		  HelpForGivenChallenges: selecteddeAsraAbleHelpforChallegesGoalsOption?.value ?? null,
		};
  
		api.getMyServiceRequestsFacilitator(
		  icurrentPage + 1,
		  pageSize,
		  sortParams,
		  dateFilter,
		  fromDate,
		  toDateAdjusted,
		  customerFilterValue,
		  customerFilter,
		  serviceStatusList,
		  selectedServiceNames,
		  PackageList,
		  selectedServicesThroughPackageOption,
		  filters.IntroductoryCall,
		  filters.CallConnectedStatus,
		  filters.EngagementCallStayEngaged,
		  filters.DoesUserSharedChallenges,
		  filters.HelpForGivenChallenges
		).then(({ data }) => {
  
		  setcurrentPage(icurrentPage);
		  setPages(Math.floor((data.count - 1) / pageSize + 1));
		  setPageSize(pageSize);
  
		  const enriched = data.results.map(d => {
			d.statusArray = buildStatusArray(d, statusList);
			return d;
		  });
  
		  setServiceRequests(enriched);
		  setLoader(false)
		  setNewServiceRequests(enriched.filter(e =>
			Math.abs(new Date(e.dtUpdated).getMinutes() - new Date(e.dtServiceProgression).getMinutes()) < 3
		  ));
		  setBackFromPartnerServiceRequests(enriched.filter(e =>
			e.refCurrentState.sServiceState === "Service deliverables ready"
		  ));
		  setPaymentReceivedServiceRequests(enriched.filter(e =>
			e.refCurrentState.sServiceState === "Full Payment Received"
		  ));
		  setTableData(enriched);


		// api.getMyServiceRequestsFacilitatorOldData(
		// 	icurrentPage + 1,
		// 	pageSize,
		// 	sortParams,
		// 	dateFilter,
		// 	fromDate,
		// 	toDateAdjusted,
		// 	customerFilterValue,
		// 	customerFilter,
		// 	serviceStatusList,
		// 	selectedServiceNames,
		// 	PackageList,
		// 	selectedServicesThroughPackageOption,
		// 	filters.IntroductoryCall,
		// 	filters.CallConnectedStatus,
		// 	filters.EngagementCallStayEngaged,
		// 	filters.DoesUserSharedChallenges,
		// 	filters.HelpForGivenChallenges).then(({ data }) => {
		// 	const enrichedDue = data.results.map(d => {
		// 	  d.statusArray = buildStatusArray(d, statusList);
		// 	  return d;
		// 	});
		// 	//   setServiceRequests(enrichedDue)
		// 	setServiceRequestsDueToday(enrichedDue);
		//   }).catch(err => console.error("Due Today API failed", err));
  
  
		
  
  
		  api.getServicePartners({}).then(({ data }) => {
			const servicePartners = Object.entries(data).map(([key]) => ({
			  checked: false,
			  label: key,
			  id: key,
			  code: key,
			  uniqueId: key,
			}));
			setServicePartnerList(servicePartners);
		  }).catch(err => console.error("Partner API failed", err));
  
		  resolve();
		}).catch(err => {
		  console.error("Main API failed:", err);
		  setLoader(false)
		  reject(err);
		});
	  } catch (error) {
		console.error("Unexpected error in getServices1:", error);
		setLoader(false)
		reject(error);
	  }
	});
  };

  // Utility: Generate adjusted toDate
const getAdjustedToDate = (date) => {
	if (!date) return null;
	const adjusted = new Date(date);
	return new Date(adjusted.setTime(adjusted.getTime() + 24 * 60 * 60 * 1000 - 1000));
  };
  
  
		const getServicesInterval = (instance, flag = null) => {
			if (!instance) return;
			if (!tableInstance) setTableInstance(instance);
			if (!getUser()) {
				history.push("/login");
			}
			// fetchallCatalogs();
			setUser(getUser());
			setTableDataType("serviceRequests");
	
			// if (instance && instance.state) {
			// 	page = instance.state.page;
			// }
	
			// if(instance && instance.state) {
			// 	pageSize = instance.state.pageSize;
			// }
	
			const { page } = instance.state ?? { page: 0 };
			let icurrentPage = page;
			if (!flag && isNaN(icurrentPage)) return;
			const pageSize = selectedPageSizeOption.value;
	
			if (flag || isNaN(icurrentPage)) {
				icurrentPage = 0;
			}
	
	
	
	
	
			// const { page } = instance.state ? instance.state : { page: 0 };
			// let statusList = selectedSPMStatus;
	
			//let selectedServiceNames = selectedServiceNameList;
			let serviceRequestListtemp2 = [];
			selectedServiceNameListForFilter.map((e) => {
				serviceRequestListtemp2.push(e.value);
			});
			const selectedServiceNames = serviceRequestListtemp2
			let toDateAdjusted = new Date(toDate);
			if (toDate) {
				toDateAdjusted = new Date(
					toDateAdjusted.setTime(
						toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
					)
				);
			}
	
	
			let sortParams = null;
			if (instance.state.sorted.length > 0) {
				const { id, desc } = instance.state.sorted[0];
				sortParams = { column: id, desc };
			}
	
			let packageListtemp = [];
			selectedPackageNameListForFilter.map((e) => {
				if (e.value != "*") {
					packageListtemp.push(e.value);
				}
			});
			const PackageList = packageListtemp
	
	
			let servicestatusListtemp2 = [];
			selectedServiceStatusListForFilter.map((e) => {
				if (e.value != "*") {
					servicestatusListtemp2.push(e.value);
				}
			});
			const serviceStatusList = servicestatusListtemp2;
	
	
			const ServicesThroughPackage = selectedServicesThroughPackageOption;
	
			let IntroductoryCall = null;
			let CallConnectedStatus = null;
			let EngagementCallStayEngaged = null;
			let DoesUserSharedChallenges = null;
			let HelpForGivenChallenges = null;
	
			if (selectedIntroductoryConversationOption) {
				IntroductoryCall = selectedIntroductoryConversationOption.value;
			}
	
			if (selectedCallStatusOption) {
				CallConnectedStatus = selectedCallStatusOption.value;
			}
	
			if (selectedStayEnagegedOption) {
				EngagementCallStayEngaged = selectedStayEnagegedOption.value;
			}
	
			if (selecteduserSharedChallegesGoalsOption) {
				DoesUserSharedChallenges = selecteduserSharedChallegesGoalsOption.value;
			}
	
			if (selecteddeAsraAbleHelpforChallegesGoalsOption) {
				HelpForGivenChallenges = selecteddeAsraAbleHelpforChallegesGoalsOption.value;
			}
	
			// setIsLoadingContainer(true);
			// setIsLoadingSpinnerForMyProgression(true);
	
			api.getMyServiceRequestsFacilitator(
				icurrentPage + 1,
				pageSize,
				sortParams,
				dateFilter,
				fromDate,
				toDateAdjusted,
				customerFilterValue,
				customerFilter,
				serviceStatusList,
				selectedServiceNames,
				PackageList,
				ServicesThroughPackage,
				IntroductoryCall,
				CallConnectedStatus,
				EngagementCallStayEngaged,
				DoesUserSharedChallenges,
				HelpForGivenChallenges
			).then(({ data }) => {
				let count = data.count;
				setcurrentPage(icurrentPage);
				const totalPages = (count - 1) / pageSize + 1;
				setPages(Math.floor(totalPages));
				setPageSize(pageSize);
				let temp = statusList.map((status) => {
					data.results.map((d) => { });
				});
				console.log("data.results", data.results);
	
				let temp1 = data.results.map((d) => {
					let tempStatusArray = [];
					if (statusList.indexOf(d["refCurrentState"]["sServiceState"]) >= 0) {
						for (let i = 0; i < 11; i++) {
							if (d["refCurrentState"]["sServiceState"] === "Cancelled") {
								tempStatusArray.push("disable");
							}
							else {
								if (i <= statusList.indexOf(d["refCurrentState"]["sServiceState"])) {
									tempStatusArray.push("status-reached");
								}
								else if (i == statusList.indexOf(d["refCurrentState"]["sServiceState"]) + 1) {
									tempStatusArray.push("");
								}
								else {
									tempStatusArray.push("disable");
								}
							}
						}
						if (d["sPaymentMode"] !== "2_Step_Payment" && d["sPaymentMode"] !== "SP_paid_service") {
							// tempStatusArray[5] = "disable";
							// tempStatusArray[6] = "disable";
							if (d["refCurrentState"]["sServiceState"] === "Service deliverables ready")
								tempStatusArray[8] = "";
						}
						tempStatusArray[9] = "";
						tempStatusArray[10] = "";
						if (d["refCurrentState"]["sServiceState"] === "Delivered") {
							tempStatusArray[9] = "disable";
							tempStatusArray[10] = "disable";
						}
						if (d["refCurrentState"]["sServiceState"] === "Cancelled") {
							tempStatusArray[9] = "status-reached";
						}
	
						if (d["sPaymentMode"] === "2_Step_Payment" && d["sNEFTTxnId_2"] !== null) {
							if (d["refCurrentState"]["sServiceState"] === "Full Payment Requested"){
								tempStatusArray[8] = "";
							}
								
						}
	
						if (d["sPaymentMode"] === "SP_paid_service" || d['sPaymentReceiver'] === "Partner") {
	
							if (d["refCurrentState"]["sServiceState"] ==="Service deliverables ready")
					{
						tempStatusArray[8] = "";
					}
							if (d["refCurrentState"]["sServiceState"] === "Ready For Progression") {
								tempStatusArray[1] = "";
							}
							else {
								tempStatusArray[1] = "status-reached";
							}
						}
						else {
							tempStatusArray[3] = "disable";
							if (d["refCurrentState"]["sServiceState"] === "Ready For Progression") {
								tempStatusArray[1] = "";
							}
							if (d["refCurrentState"]["sServiceState"] === "Info & Docs Received") {
								tempStatusArray[3] = "disable";
								tempStatusArray[4] = "";
							}
						}
	
						if (d["refCurrentState"]["sServiceState"] === "Cancelled") {
							tempStatusArray[0] = "disable";
							tempStatusArray[1] = "disable";
							tempStatusArray[2] = "disable";
							tempStatusArray[3] = "disable";
							tempStatusArray[4] = "disable";
							tempStatusArray[5] = "disable";
							tempStatusArray[8] = "disable";
							tempStatusArray[9] = "status-reached";
							tempStatusArray[10] = "disable";
						}
	
						if (d["nPackageInstanceId"]) {
							tempStatusArray[3] = "disable";
							// tempStatusArray[5] ="disable";
							// tempStatusArray[6] ="disable";
	
							if (d["nPackageInstanceId"]) {
								tempStatusArray[3] = "disable";
								// tempStatusArray[4] = "";
	
								// tempStatusArray[5] ="disable";
								// tempStatusArray[6] ="disable";
	
								if (d["refCurrentState"]["sServiceState"] === "Info & Docs Received") {
									tempStatusArray[3] = "disable";
									tempStatusArray[4] = "";
								}
								// if (d["refCurrentState"]["sServiceState"] === "Ready For Progression" ||
								// 	d["refCurrentState"]["sServiceState"] === "Payment Confirmed by Partner") {
								// 	tempStatusArray[1] = "";
								// }
	
								if (d["refCurrentState"]["sServiceState"] === "Service deliverables ready") {
									tempStatusArray[8] = "";
								}
							}
						}
	
						if (d["bCouponApplied"] && (d["fAmountSecond"] <= d["fDiscountAmount"])) {
							// tempStatusArray[5] = "disable";
							// tempStatusArray[6] = "disable";
							if (d["refCurrentState"]["sServiceState"] === "Service deliverables ready") {
								tempStatusArray[8] = "";
							}
						}
					}
					d["statusArray"] = tempStatusArray;
					console.log("New Array=", d["statusArray"])
					return d;
				});
	
				setServiceRequests(temp1);
				// setIsLoadingSpinnerForMyProgression(false);
				
			});
		};
	

	useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		api.getAllServiceRequestsNames().then(({ data }) => {
			const serviceReqNames = Object.keys(data).map((idx) => {
				return {
					checked: selectedServiceNameList.includes(
						data[idx].sServiceCode
					),
					label: data[idx].sServiceName,
					id: data[idx].id,
					code: data[idx].sServiceCode,
				};
			});
			setServiceNameList(serviceReqNames);
			const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sServiceName,
					id: data[idx].id,
					value: data[idx].sServiceCode,
				};
			});
			setServiceNameListForFilter(serviceReqNamesForFilter);
		});

		api.getAllPackageCatalogues().then(({ data }) => {
			const packageNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sPackageOfferTitle,
					id: data[idx].id,
					value: data[idx].id,
				};
			});
			setPackageNameListForFilter(packageNamesForFilter);
		});

		// api.getAllServiceRequestsStatus().then(({ data }) => {
		// 	const serviceReqStatus = Object.keys(data).map((idx) => {
		// 		return {
		// 			checked: selectedServiceRequestStatusList.includes(
		// 				data[idx].id
		// 			),
		// 			label: data[idx].sSRState,
		// 			id: data[idx].sSRState,
		// 			code: data[idx].sSRState,
		// 		};
		// 	});
		// 	setServiceRequestStatusList(serviceReqStatus);

		// 	const serviceStatus = Object.keys(data).map((idx) => {
		// 		return {
		// 			label: data[idx].sSRState,
		// 			value: data[idx].sSRState,
		// 			id: data[idx].sSRState,
		// 		};
		// 	});
		// 	setServiceStatusNameListForFilter(serviceStatus);
		// });

		const serviceStatus = SPMStatusList.map((idx) => {
			return {
				label: idx.id,
				value: idx.id,
				id: idx.id,
			};
		});
		setServiceStatusNameListForFilter(serviceStatus);


		// getServices(instance);
	}, [serviceRequestFilter]);

	// const fetchServiceRequests = (instance, flag) => {
	// 	getAllServiceRequests(instance, flag);
	// };

	/**Date range */
	const [fromDate, setFromDate] = useState();
	const [toDate, setToDate] = useState();
	const [dateRangeOption, setDateRangeOptions] = useState([
		{
			value: "dtServiceProgression",
			label: "Progression On",
		},
		{
			value: "dtLastFacilitatorAssigned",
			label: "Facilitator Assigned On"
		},
		{
			value: "dtFollowupOn",
			label: "Followup On",
		},
		// {
		// 	value: "dtCreated",
		// 	label: "Creation Date",
		// },
		// {
		// 	value: "dtUpdated",
		// 	label: "Updation Date",
		// },

	]);

	const onDateRangeChange = (dateLable, dateValue) => {
		if (dateLable === "fromDate") {
			setFromDate(dateValue);
		}
		if (dateLable === "toDate") {
			setToDate(dateValue);
		}
	};

	const [dateFilter, setDateFilter] = useState({
		value: "dtServiceProgression",
		label: "Progression On",
	});

	const onDateFilterChange = (e) => {
		setDateFilter(e);
	};
	/**State audit log */
	const [stateAuditLog, setStateAuditLog] = useState();

	useEffect(() => {
		if (selectedServiceRequest) {
			api.getStateAuditLogSPM(
				selectedServiceRequest["nResourceInstanceId"]
			).then((d) => {
				setStateAuditLog(d.data);
			});
		}

		// const intervalId = setInterval(() => {
		// 	if (tableInstance) {
		// 	  getServicesInterval(tableInstance);
		// 	}
		//   }, 40000);
		
		//   return () => {
		// 	clearInterval(intervalId);
		//   };
	}, [selectedServiceRequest]);

	useEffect(() => {
		if (!tableInstance) return;

		const intervalId = setInterval(() => {
			getServicesInterval(tableInstance);
		}, 40000);

		return () => clearInterval(intervalId);

	}, [
		tableInstance,
		selectedServiceNameListForFilter,
		selectedPackageNameListForFilter,
		selectedServiceStatusListForFilter,
		selectedIntroductoryConversationOption,
		selectedCallStatusOption,
		selectedStayEnagegedOption,
		selecteduserSharedChallegesGoalsOption,
		selecteddeAsraAbleHelpforChallegesGoalsOption,
		fromDate,
		toDate,
		selectedPageSizeOption?.value
	]);

	const calculateEnableOtherDescriptionTextbox = () => {
		if (
			selectedCancellationReason &&
			selectedCancellationReason.value === "Other"
		)
			setEnableOtherDescriptionTextbox(true);
		else setEnableOtherDescriptionTextbox(false);
	};

	useEffect(() => {
		calculateEnableOtherDescriptionTextbox();
	}, [selectedCancellationReason]);

	useEffect(() => {
		setSelectedCancellationReason();
		setCancellationReasonOtherDescription();
		if (selectedServiceRequest && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequest.sServiceCancellationReason) {
					setSelectedCancellationReason(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescription(
							selectedServiceRequest.sServiceCancellationReasonOtherDescription
						);
					}
				}
			});
		}

		// setSelectedCancellationReason();
	}, [selectedServiceRequest, selectedService]);

	useEffect(() => {
		const { temp } = api.getCancellationReasons().then(({ data }) => {
			let temp1 = data.map((e) => {
				return { value: e.sReason, label: e.sReason };
			});
			setCancellationReasonDropdownOptions(temp1);
		});
	}, []);

	useDebouncedEffect(
		() => {
			// getServices(tableInstance);
		},
		2000,
		[
			// fromDate,
			// toDate,
			// dateFilter,
			// customerFilterValue,
			// selectedSPMStatus,
			// selectedServiceNameList,
			tableInstance,
		]
	);

	/*Callbacks for service filter */
	const toggleAllForFilter = () => {
		let temp = [];

		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
			if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
				temp = selectedServiceNameListForFilter;
			}
			else {
				temp = [{ label: "All", value: "*" }];
			}

			let tempSR = serviceNameListForFilter.map((e) => {
				if (!temp.includes(e)) {
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
			getServices(tableInstance);
		}
		else {
			setSelectedServiceNameListForFilter([]);
			getServices(tableInstance);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};
	/* Callbacks for service filter */

	/*Callbacks for Package filter */
	const toggleAllForPackageFilter = () => {
		let temp = [];

		if (selectedPackageNameListForFilter.length != packageNameListForFilter.length && selectedPackageNameListForFilter.length != (packageNameListForFilter.length + 1)) {
			if (selectedPackageNameListForFilter.includes({ label: "All", value: "*" })) {
				temp = selectedPackageNameListForFilter;
			}
			else {
				temp = [{ label: "All", value: "*" }];
			}

			let tempSR = packageNameListForFilter.map((e) => {
				if (!temp.includes(e)) {
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedPackageNameListForFilter(temp);
			setPackageNameListForFilter(tempSR);
			getServices(tableInstance);
		}
		else {
			setSelectedPackageNameListForFilter([]);
			getServices(tableInstance);
		}
	};

	const toggleSelectionForPackageFilter = (e) => {
		setSelectedPackageNameListForFilter(e);
	};
	/* Callbacks for Package filter */

	const toggleAllForServiceStatusFilter = () => {
		let temp = [];

		if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
			if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
				temp = selectedServiceStatusListForFilter;
			}
			else {
				temp = [{ label: "All", value: "*" }];
			}

			let tempSR = serviceStatusNameListForFilter.map((e) => {
				if (!temp.includes(e)) {
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceStatusListForFilter(temp);
			setServiceStatusNameListForFilter(tempSR);
			//getExternalPartnerServices(tableInstance);
		}
		else {
			setSelectedServiceStatusListForFilter([]);
			//getExternalPartnerServices(tableInstance);
		}
	};

	const toggleSelectionForServiceStatusFilter = (e) => {
		setSelectedServiceStatusListForFilter(e);
	};

	/*Need to talk to sp callback */
	const onUpdateNeedToTalkToSPFlag = async () => {
		let bNeedToTalkToSP = selectedNeedToTalkToSPOption.value;
		const { nResourceInstanceId } = selectedServiceRequest;
		api.updateNeedtoTalkToSPFlagSPM(nResourceInstanceId, { bNeedToTalkToSP })
			.then((response) => {
				if (response.status == 202) {
					setSelectedServiceRequest({ ...selectedServiceRequest, bNeedToTalkToSP: bNeedToTalkToSP })
					if (response.data.message) {
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else {
						toast("Service updated successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				}
				else {
					if (response.data.message) {
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else {
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
				}
				//toggleNotesModal();
				//getServices(tableInstance);				
			})
			.catch((error) => {
				toast(String(error.response.data.message), {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};
	/*end*/

	//offline meet api//

	// const onUpdateOfflineMeetoptions = async (selectedService) => {
	//     try
	//     {

	// const {
	//     nResourceInstanceId="nResourceInstanceId",
	//     custbOfflineMeet 
	// } = selectedService;


	// var bOfflineMeet=selectedofflinemeetoptions.value;
	// if(custbOfflineMeet)
	// {
	//     bOfflineMeet=custbOfflineMeet;
	// }

	// const payload = {
	//     nResourceInstanceId,
	//     bOfflineMeet:bOfflineMeet,
	// };
	//         setIsLoading(true);
	//         const { data: _ignore_ } = await api
	//             .updateOfflineMeet(payload)
	//             .then((d) => {
	//                 if (d.data) 
	//                 {
	//                     setIsLoading(false);
	//                     toast("Offline meet status updated successfully.", {
	//                         autoClose: 5000,
	//                         type: toast.TYPE.SUCCESS,
	//                     });
	//                     //setSelectedServiceForEdit();
	//                     //setSelectedSecondServiceForEdit();  
	//                     //getServices(tableInstance); 
	//                 }
	//             })
	//             .catch((error) =>
	//             {
	//                 setIsLoading(false);
	//                 toast(String(error.response.data.detail), {
	//                     autoClose: 5000,
	//                     type: toast.TYPE.ERROR,
	//                 });
	//             });
	//     } 
	//     catch (error)
	//     {
	//         setIsLoading(false);
	//     }            
	// };

	const onUpdateOfflineMeetoptions = async () => {


		const {
			nResourceInstanceId,
			custbOfflineMeet
		} = selectedServiceRequest;


		var bOfflineMeet = selectedofflinemeetoptions.value;
		if (custbOfflineMeet) {
			bOfflineMeet = custbOfflineMeet;
		}

		const payload = {
			nResourceInstanceId,
			bOfflineMeet: bOfflineMeet,
		};

		//let bOfflineMeet=selectedofflinemeetoptions.value;	
		//const nResourceInstanceId = selectedServiceRequest;
		api.updateOfflineMeet(payload)
			.then((response) => {
				if (response.status == 202) {
					setSelectedServiceRequest({ ...selectedServiceRequest, bOfflineMeet: bOfflineMeet })
					if (response.data.message) {
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else {
						toast("Service updated successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				}
				else {
					if (response.data.message) {
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else {
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
				}
				//toggleNotesModal();
				//getServices(tableInstance);				
			})
			.catch((error) => {
				toast(String(error.response.data.message), {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};
	//End




	/*Show More*/

	// let filterParameters = { pages, ...sortParams };

	//  let sortParams = "";
	// 	// if (instance.state.sorted.length > 0) {
	// 	// 	const { id, desc } = instance.state.sorted[0];
	// 	// 	sortParams = { column: id, desc };
	// 	// }


	// SearchByDropdownList.map((x) => {
	// 	if (x.selected && customerFilterValue)
	// 	{
	// 		if(x.code==="notes")
	// 		{
	// 			filterParameters["filter_by"] = "props.toggleNotesModal(notes)";

	// 		}
	// 		else if(x.code==="/home/three-sixty-degree-view/")
	// 		{
	// 			filterParameters["filter_by"] = "/home/three-sixty-degree-view/" ;
	// 		}
	// 		else if(x.code==="DND_LINK")
	// 		{

	// 			filterParameters["filter_by"]="DND_LINK";
	// 		}

	// 		filterParameters["filter_value"] = customerFilterValue;
	// 	}
	// });



	// let SearchByOptions=[
	// 	{
	// 		//selected: false,
	// 		label: "Add Notes",
	// 		id: "notes",
	//         code: "props.toggleNotesModal(original)",
	// 	},
	//     {
	// 		//selected: false,
	// 		label: "DND Update Link",
	// 		id: "DNDUpdateLink",
	//         code: "DNDUpdateLink",
	// 	},
	//     {
	// 		//selected: false,
	// 		label: "360 Degree View	",
	// 		id: "360DegreeView",
	//         code: "360DegreeView",
	// 	},

	// ];



	//statusList for filter

	const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};



	//const [SearchByDropdownList, setSearchByDropdownList] = useState(SearchByOptions);
	const [isSearchByDropdownOpen, setisSearchByDropdownOpen] = useState(false);
	const [selectedServiceForKnowMore, setSelectedServiceForKnowMore] = useState(null);

	const onKnowMoreClick = (original) => {
		setSelectedServiceForKnowMore(original);
		toggleSearchByVisibility();
	}


	const toggleSearchByVisibility = () => {
		setisSearchByDropdownOpen(!isSearchByDropdownOpen);
	}

	//const ColumnDropdownRef = useRef();
	const SearchDropdownRef = useRef();
	useEffect(() => {
		const interval = setInterval(() => {
			if (isSearchByDropdownOpen) {
				document.addEventListener("click", close);
			}
			else {
				document.removeEventListener("click", close);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", close);
		};
	});

	const close = (e) => {

		if (isSearchByDropdownOpen) {
			if (SearchDropdownRef.current && SearchDropdownRef.current.contains(e.target)) {
				return;
			}
			toggleSearchByVisibility();
			setSelectedServiceForKnowMore(null);
		}
	};


	//export to excell//

	//expand
	const [ExpandedChange, setExpandedChange] = useState({});



	return (
		<>
			<div className={`row ${isLoadingContainer && "set-opacity"}`}>
				{isLoadingContainer && <Spinner className="center-screen" />}
				{
					<>
						<FacilitatorFilterSection
							toggleFilterModal={toggleFilterModal}
							toggleEngagementFiltersModal={toggleEngagementFiltersModal}
							onCustomerFilterValueChange={onCustomerFilterValueChange}
							onSearchClicked={onSearchClicked}
							customerFilterValue={customerFilterValue}
							onClearAllClicked={onClearAllClicked}
							toggleSearchByVisibility={toggleSearchByVisibility}
							SearchDropdownRef={SearchDropdownRef}
							data={serviceRequests}
						//csvReport={csvReport}
						//onSearchClicked={handleSearchClick}
						/>

						<FacilitatorServiceTable
							user={getUser()}
							data={serviceRequests}
							isLoadingSpinnerForMyProgression={isLoadingSpinnerForMyProgression}
							selectedServiceRequest={selectedServiceRequest} //{selectedServiceRequests}
							onSelectServiceRequest={setSelectedServiceRequest} //{setSelectedServiceRequests}
							onFetchServiceRequests={getServices} //{fetchServiceRequests}
							pages={pages}
							pageSize={pageSize}
							page={currentPage}
							pageSizeOptions={pageSizeOptions}
							selectedPageSizeOption={selectedPageSizeOption}
							onPageSizeOptionChange={(option) => {
								setSelectedPageSizeOption(option);
							}}
							stateAuditLog={stateAuditLog}
							// searchTerm={searchTerm}
							/**
							 * user profile
							 */
							toggleUserProfileModal={handleOnClickUser}
							updateStatusArray={updateStatusArray}
							/**
							 * NEFT Modal
							 */
							isNeftModalOpen={showNeftModal}
							toggleNeftModal={toggleNeftModal}
							neftDetails={neftDetails}
							onNeftDetailsChanged={handleNeftDetailsChanged}
							onSaveNeftDetails={handleSaveNeftDetails}
							/**Misc */
							sendPaymentLink={sendPaymentLinkSPM}
							/**
							 * Notes Modal
							 */
							auditTrail={auditTrail}
							changeSelectedNotesDetails={changeSelectedNotesDetails}
							notesHistory={notesHistory}
							notesDetails={notesDetails}
							showNotesModal={showNotesModal}
							toggleNotesModal={toggleNotesModal}
							onNotesChange={onNotesChange}
							onSaveNotesDetails={onSaveNotesDetails}
							showConfirmationModalNotes={showConfirmationModal}
							toggleConfirmationModalNotes={toggleConfirmationModalNotes}
							confirmChangeNotes={confirmChangeNotes}
							/**
							 * Service Partner Modal
							 *
							 */

							/**/
							//isOpen={props.showFeedbackModal}
							// showFeedbackModal={showFeedbackModal}
							// toggleShowFeedbackModal={toggleShowFeedbackModal}
							toggleShowFeedbackModal={handleOnShowFeedback}
							/** */


							showServicePartnerModal={showServicePartnerModal}
							toggleServicePartnerModal={toggleServicePartnerModal}
							servicePartnerList={servicePartnerList}
							currentServicePartner={currentServicePartner}
							saveServicePartner={saveServicePartner}
							toggleServicePartner={toggleServicePartner}
							/**
							 * External Service Partner List
							 */

							showExternalServicePartnerModal={
								showExternalServicePartnerModal
							}
							isLoading={isLoading}
							toggleExternalServicePartnerModal={
								toggleExternalServicePartnerModal
							}
							externalServicePartnerList={externalServicePartnerList}
							currentExternalServicePartner={currentExternalServicePartner}
							saveExternalServicePartner={saveExternalServicePartner}
							toggleExternalServicePartner={toggleExternalServicePartner}
							/**
							 * Status column api calls
							 */
							isLoadingStateChange={isLoadingStateChange}
							changeState={chanegState}
							/**
							 * catalog modal
							 */
							showCatalogModalClick={showCatalogModalClick}
							allCatalogs={allCatalogs}
							/**
							 * Cancellation Modal
							 */
							enableCancelButtonFlag={enableCancelButtonFlag}
							showCancellationReasonModal={showCancellationReasonModal}
							toggleCancellationReasonModal={toggleCancellationReasonModal}
							cancellationReasonDropdownOptions={
								cancellationReasonDropdownOptions
							}
							setSelectedCancellationReason={setSelectedCancellationReason}
							selectedCancellationReason={selectedCancellationReason}
							enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
							cancellationReasonOtherDescription={
								cancellationReasonOtherDescription
							}
							onChangeCancellationReasonOtherDescription={(value) =>
								setCancellationReasonOtherDescription(value)
							}
							showSendNeftDetailsModal={showSendNeftDetailsModal}
							setShowSendNeftDetailsModal={setShowSendNeftDetailsModal}

							/**Refund Modal */
							isLoadingRefund={isLoadingRefund}
							isRefundModalOpen={showRefundModal}
							toggleRefundModal={toggleRefundModal}
							refundDetails={refundDetails}
							onRefundDetailsChanged={onRefundDetailsChanged}
							onSaveRefundDetails={onSaveRefundDetails}
							onSelectCancellationReasonforRefund={setSelectedCancellationReasonForRefund}
							selectedCancellationReasonforRefund={selectedCancellationReasonForRefund}
							enableOtherDescriptionTextboxforRefund={enableOtherDescriptionTextboxForRefund}
							cancellationReasonOtherDescriptionforRefund={cancellationReasonOtherDescriptionforRefund}
							onChangeCancellationReasonOtherDescriptionforRefund={setCancellationReasonOtherDescriptionforRefund}
							/** */

							/*Need to talk to SP */
							needToTalkToSPOptions={needToTalkToSPOptions}
							selectedNeedToTalkToSPOption={selectedNeedToTalkToSPOption}
							setSelectedNeedToTalkToSPOption={setSelectedNeedToTalkToSPOption}
							onUpdateNeedToTalkToSPFlag={onUpdateNeedToTalkToSPFlag}
							/*End*/

							//offline meet //
							offlinemeetoptions={offlinemeetoptions}
							selectedofflinemeetoptions={selectedofflinemeetoptions}
							setselectedofflinemeetoptions={setselectedofflinemeetoptions}
							onUpdateOfflineMeetoptions={onUpdateOfflineMeetoptions}

							//End//

							/*Feedback Modal*/
							//toggleShowFeedbackModal={handleOnShowFeedback}

							/*Show more*/
							//SearchByDropdownList={SearchByDropdownList}
							isSearchByDropdownOpen={isSearchByDropdownOpen}
							toggleSearchByVisibility={toggleSearchByVisibility}
							SearchDropdownRef={SearchDropdownRef}
							onKnowMoreClick={onKnowMoreClick}
							selectedServiceForKnowMore={selectedServiceForKnowMore}
							//selectSearchBySelection={selectSearchBySelection}

							ExpandedChange={ExpandedChange}
							setExpandedChange={setExpandedChange}
							setResourceId={setResourceId}
							extendedData={extendedData}
							progressionDate={progressionDate}
							loader={loader}

						/>
						{
							showFilterModal && (
								<SPMFilterModel
									isOpen={showFilterModal}
									toggleModal={toggleFilterModal}

									onSearchClicked={handleSearchClick}
									onClearFilterSearch={handleClearFilterSearch}

									dateRangeOption={dateRangeOption}
									onDateFilterChange={onDateFilterChange}
									dateFilter={dateFilter}
									onDateRangeChange={onDateRangeChange}
									fromDate={fromDate}
									toDate={toDate}

									toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
									toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
									selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
									serviceStatusNameListForFilter={serviceStatusNameListForFilter}

									toggleAllForFilter={toggleAllForFilter}
									toggleSelectionForFilter={toggleSelectionForFilter}
									serviceNameListForFilter={serviceNameListForFilter}
									selectedServiceNameListForFilter={selectedServiceNameListForFilter}

									toggleAllForPackageFilter={toggleAllForPackageFilter}
									toggleSelectionForPackageFilter={toggleSelectionForPackageFilter}
									packageNameListForFilter={packageNameListForFilter}
									selectedPackageNameListForFilter={selectedPackageNameListForFilter}


								/>
							)
						}

						{
							showUserProfileModal &&
							(
								<UserProfileModal
									isOpen={showUserProfileModal}
									toggleModal={toggleUserProfileModal}
									userProfileInitData={userProfileInitData}
									userProfileEditableData={userProfileEditableData}
									onInputChange={handleUserProfileDataChanged}
									createUserProfile={createUserProfile}
									updateSelectedServiceRequest={updateSelectedServiceRequest}
									nUserId={nUserId}
									nResourceInstanceIdForUserProfile={nResourceInstanceIdForUserProfile}
									showFacilitatorEngagementView={false}
									sBusinessNameForUserProfile={sBusinessNameForUserProfile}
									sSectorNameForUserProfile={sSectorNameForUserProfile}
									sCurrentServiceRequestStateForUserProfile={sCurrentServiceRequestStateForUserProfile}
									refExternalServicePartnerEmailIDForFeedback={refExternalServicePartnerEmailIDForFeedback}
								/>

							)
						}

						{
							showEngagementFiltersModal &&
							(
								<EngagementFiltersModal
									isOpen={showEngagementFiltersModal}
									toggleModal={toggleEngagementFiltersModal}
									ItroductoryConversationOptions={introductoryConversationOptions}
									selectedIntroductoryConversationOption={selectedIntroductoryConversationOption}
									onChangeIntroductoryConversationOption={(value) =>
										setSelectedIntroductoryConversationOption(value)
									}
									callStatusOptions={callStatusOptions}
									selectedCallStatusOption={selectedCallStatusOption}
									onChangeCallStatusOption={(value) =>
										setSelectedCallStatusOption(value)
									}
									StayEnagegedOptions={StayEnagegedOptions}
									selectedStayEnagegedOption={selectedStayEnagegedOption}
									onChangeStayEnagegedOption={(value) =>
										setSelectedStayEnagegedOption(value)
									}
									userSharedChallegesGoalsOptions={userSharedChallegesGoalsOptions}
									selecteduserSharedChallegesGoalsOption={selecteduserSharedChallegesGoalsOption}
									onChangeuserSharedChallegesGoalsOption={(value) =>
										setSelecteduserSharedChallegesGoalsOption(value)
									}
									deAsraAbleHelpforChallegesGoalsOptions={deAsraAbleHelpforChallegesGoalsOptions}
									selecteddeAsraAbleHelpforChallegesGoalsOption={selecteddeAsraAbleHelpforChallegesGoalsOption}
									onChangedeAsraAbleHelpforChallegesGoalsOption={(value) =>
										setSelecteddeAsraAbleHelpforChallegesGoalsOption(value)
									}
									onEngagementFilterSearchClicked={onEngagementFilterSearchClicked}
									onClearEngagementFilterClicked={onClearEngagementFilterClicked}

								>
								</EngagementFiltersModal>

							)
						}

						{
							showServiceFeedbackModal &&
							(
								<UserFeedbackModal
									isOpen={showServiceFeedbackModal}
									toggleModal={toggleServiceFeedbackModal}
									sEmailAddress={null}
									nResourceInstanceId={nResourceInstanceIdForFeedback}
									sServiceNameForFeedback={sServiceNameForFeedback}
									refExternalServicePartnerEmailIDForFeedback={refExternalServicePartnerEmailIDForFeedback}
								>
								</UserFeedbackModal>
							)
						}

						{
							showSendNeftDetailsModal && (
								<SendNeftDetails
									isOpen={showSendNeftDetailsModal}
									toggleModal={onSetShowSendNeftDetailsModal}
									neftPaymentDetails={neftPaymentDetails}
									// getNeftPaymentDetails={getNeftPaymentDetails}
									onClickSendNeftAccountDetails={
										onClickSendNeftAccountDetails
									}
								/>
							)
						}

					</>
				}
			</div>
		</>

	);
}
